/**
 * Widget CSS - Generated from app.js createWidget() CSS
 * This module exports a function that generates all widget styles
 */

/**
 * Generate all widget CSS styles
 * @param {Object} config - Widget configuration
 * @param {Object} darkColors - Dark mode color overrides
 * @param {boolean} isSDKMode - Whether in SDK mode
 * @returns {string} Complete CSS string
 */
export function generateWidgetCSS(config, darkColors = {}, isSDKMode = false) {
  // Ensure primaryColor has a valid fallback value
  const primaryColor = config.primaryColor || '#007bff';

  return `
:root,
#fyncall-widget-container {
    --fyncall-primary: ${primaryColor};
    --fyncall-primary-light: ${primaryColor}15;
    --fyncall-text: #333;
    --fyncall-text-light: #6c757d;
    --fyncall-bg: #f8f9fa;
    --fyncall-white: #ffffff;
    --fyncall-border: #e9ecef;
    --fyncall-success: #28a745;
    --fyncall-warning: #ffc107;
    --fyncall-danger: #dc3545;
}

/* Dark Mode Theme Variables */
#fyncall-widget-container[data-theme="dark"] {
    --fyncall-primary: ${darkColors.primary_color || primaryColor};
    --fyncall-primary-light: ${darkColors.primary_color || primaryColor}15;
    --fyncall-text: ${darkColors.text_color || '#e5e5e5'};
    --fyncall-text-light: ${darkColors.secondary_color || '#9ca3af'};
    --fyncall-bg: ${darkColors.background_color || '#1f2937'};
    --fyncall-white: ${darkColors.surface_color || '#111827'};
    --fyncall-border: ${darkColors.border_color || '#374151'};
}

#fyncall-widget-container[data-theme="dark"] #fyncall-chat-window {
    background: var(--fyncall-white);
}
#fyncall-widget-container[data-theme="dark"] #fyncall-messages {
    background: var(--fyncall-bg);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-message.bot .fyncall-message-content {
    background: ${darkColors.surface_color || '#374151'};
    color: var(--fyncall-text);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-input-wrapper {
    background: ${darkColors.surface_color || '#374151'};
    border-color: var(--fyncall-border);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-input-wrapper:focus-within {
    background: ${darkColors.surface_color || '#374151'};
    border-color: var(--fyncall-primary);
}
#fyncall-widget-container[data-theme="dark"] #fyncall-input {
    background: transparent;
    color: var(--fyncall-text);
}
#fyncall-widget-container[data-theme="dark"] #fyncall-input::placeholder {
    color: var(--fyncall-text-light);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-input-action {
    color: var(--fyncall-text-light);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-input-action:hover {
    background: rgba(255,255,255,0.1);
    color: var(--fyncall-primary);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-prechat,
#fyncall-widget-container[data-theme="dark"] .fyncall-csat,
#fyncall-widget-container[data-theme="dark"] .fyncall-cart-panel,
#fyncall-widget-container[data-theme="dark"] .fyncall-home-screen {
    background: var(--fyncall-white);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-prechat-field input,
#fyncall-widget-container[data-theme="dark"] .fyncall-prechat-field select,
#fyncall-widget-container[data-theme="dark"] .fyncall-prechat-field textarea,
#fyncall-widget-container[data-theme="dark"] .fyncall-csat-followup textarea {
    background: ${darkColors.surface_color || '#374151'};
    color: var(--fyncall-text);
    border-color: var(--fyncall-border);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-product-card,
#fyncall-widget-container[data-theme="dark"] .fyncall-cart-item {
    background: ${darkColors.surface_color || '#374151'};
    border-color: var(--fyncall-border);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-quick-reply,
#fyncall-widget-container[data-theme="dark"] .fyncall-faq-item,
#fyncall-widget-container[data-theme="dark"] .fyncall-action-card,
#fyncall-widget-container[data-theme="dark"] .fyncall-faq-section {
    background: ${darkColors.surface_color || '#374151'};
    border-color: var(--fyncall-border);
    color: var(--fyncall-text);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-home-content {
    background: var(--fyncall-bg);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-home-search-input {
    background: ${darkColors.surface_color || '#374151'};
    color: var(--fyncall-text);
    box-shadow: 0 4px 12px rgba(0,0,0,0.2);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-home-section-label {
    color: var(--fyncall-text-light);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-action-text {
    color: var(--fyncall-text);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-faq-item::before {
    background: var(--fyncall-border);
    color: var(--fyncall-text-light);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-modal {
    background: var(--fyncall-white);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-proactive {
    background: ${darkColors.surface_color || '#374151'};
    color: var(--fyncall-text);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-powered {
    background: var(--fyncall-bg);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-powered a {
    color: var(--fyncall-text-light);
}

#fyncall-widget-container {
    ${isSDKMode ? `
    /* SDK Mode: Fill the iframe */
    position: relative;
    width: 100%;
    height: 100%;
    ` : `
    /* Standalone Mode: Fixed position */
    position: fixed;
    z-index: 9999;
    right: ${config.launcherPositionOffset?.x || 20}px;
    bottom: ${config.launcherPositionOffset?.y || 20}px;
    `}
    font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
}

/* Launcher Button - Base Styles (hidden in SDK mode) */
#fyncall-launcher {
    ${isSDKMode ? 'display: none !important;' : ''}
    background: var(--fyncall-primary);
    border: none;
    cursor: pointer;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.3s ease;
    position: relative;
    gap: 8px;
    color: white;
    font-weight: 500;
    font-size: 14px;
}
#fyncall-launcher:hover { transform: scale(1.05); box-shadow: 0 6px 20px rgba(0,0,0,0.2); }
#fyncall-launcher svg { width: 28px; height: 28px; fill: white; flex-shrink: 0; }
#fyncall-launcher img { width: 28px; height: 28px; object-fit: contain; flex-shrink: 0; }
#fyncall-launcher .launcher-text { white-space: nowrap; }

/* Launcher Styles */
#fyncall-launcher.launcher-circle { border-radius: 50%; }
#fyncall-launcher.launcher-rounded { border-radius: 16px; }
#fyncall-launcher.launcher-pill { border-radius: 9999px; padding: 0 20px; }

/* Launcher Sizes */
#fyncall-launcher.launcher-small { width: 48px; height: 48px; }
#fyncall-launcher.launcher-small svg, #fyncall-launcher.launcher-small img { width: 22px; height: 22px; }
#fyncall-launcher.launcher-medium { width: 56px; height: 56px; }
#fyncall-launcher.launcher-medium svg, #fyncall-launcher.launcher-medium img { width: 26px; height: 26px; }
#fyncall-launcher.launcher-large { width: 64px; height: 64px; }
#fyncall-launcher.launcher-large svg, #fyncall-launcher.launcher-large img { width: 30px; height: 30px; }

/* Pill style overrides size for width */
#fyncall-launcher.launcher-pill.launcher-small { width: auto; min-width: 100px; height: 48px; }
#fyncall-launcher.launcher-pill.launcher-medium { width: auto; min-width: 120px; height: 56px; }
#fyncall-launcher.launcher-pill.launcher-large { width: auto; min-width: 140px; height: 64px; }

/* Launcher Animations */
@keyframes fyncall-pulse {
    0%, 100% { transform: scale(1); }
    50% { transform: scale(1.05); }
}
@keyframes fyncall-bounce {
    0%, 100% { transform: translateY(0); }
    50% { transform: translateY(-8px); }
}
@keyframes fyncall-shake {
    0%, 100% { transform: rotate(0deg); }
    25% { transform: rotate(-5deg); }
    75% { transform: rotate(5deg); }
}
#fyncall-launcher.animation-pulse { animation: fyncall-pulse 2s ease-in-out infinite; }
#fyncall-launcher.animation-bounce { animation: fyncall-bounce 1s ease-in-out infinite; }
#fyncall-launcher.animation-shake { animation: fyncall-shake 0.5s ease-in-out infinite; }
#fyncall-launcher:hover { animation: none; }

/* Unread Badge */
.fyncall-badge {
    position: absolute;
    top: -5px;
    right: -5px;
    background: var(--fyncall-danger);
    color: white;
    font-size: 11px;
    font-weight: 600;
    min-width: 20px;
    height: 20px;
    border-radius: 10px;
    display: none;
    align-items: center;
    justify-content: center;
    padding: 0 6px;
}
.fyncall-badge.show { display: flex; }

/* Proactive Message */
.fyncall-proactive {
    position: absolute;
    bottom: ${(config.launcherSize === 'small' ? 58 : config.launcherSize === 'large' ? 74 : 66)}px;
    right: 0;
    background: white;
    padding: 12px 16px;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    max-width: 280px;
    display: none;
    animation: fyncall-slideUp 0.3s ease;
}
.fyncall-proactive.show { display: block; }
.fyncall-proactive p { margin: 0 0 8px; font-size: 14px; color: var(--fyncall-text); }
.fyncall-proactive-close {
    position: absolute;
    top: 8px;
    right: 8px;
    background: none;
    border: none;
    font-size: 16px;
    cursor: pointer;
    color: var(--fyncall-text-light);
}
.fyncall-proactive-btn {
    background: var(--fyncall-primary);
    color: white;
    border: none;
    padding: 8px 16px;
    border-radius: 20px;
    font-size: 13px;
    cursor: pointer;
    transition: opacity 0.2s;
}
.fyncall-proactive-btn:hover { opacity: 0.9; }

@keyframes fyncall-slideUp {
    from { opacity: 0; transform: translateY(10px); }
    to { opacity: 1; transform: translateY(0); }
}

/* Chat Window */
#fyncall-chat-window {
    ${isSDKMode ? `
    /* SDK Mode: Always visible and fill container */
    display: flex;
    width: 100%;
    height: 100%;
    border-radius: 0;
    box-shadow: none;
    margin-bottom: 0;
    ` : `
    /* Standalone Mode */
    display: none;
    width: ${config.widgetWidth || (config.widgetSize === 'small' ? '300px' : config.widgetSize === 'large' ? '380px' : '340px')};
    height: ${config.widgetHeight || (config.widgetSize === 'small' ? '550px' : config.widgetSize === 'large' ? '720px' : '650px')};
    border-radius: ${config.borderRadius || '20px'};
    box-shadow: ${config.shadowIntensity === 'none' ? 'none' :
      config.shadowIntensity === 'light' ? '0 4px 20px rgba(0,0,0,0.08)' :
        config.shadowIntensity === 'heavy' ? '0 12px 60px rgba(0,0,0,0.25)' :
          '0 8px 50px rgba(0,0,0,0.15)'};
    margin-bottom: 10px;
    `}
    background: white;
    flex-direction: column;
    overflow: hidden;
    position: relative;
}
#fyncall-chat-window.open { display: flex; }
/* Hide launcher when chat window is open (CSS fallback for JS) */
#fyncall-chat-window.open ~ #fyncall-launcher { display: none !important; }

/* Blur Background Overlay */
${config.blurBackground ? `
#fyncall-widget-container::before {
    content: '';
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(4px);
    opacity: 0;
    visibility: hidden;
    transition: opacity 0.3s ease, visibility 0.3s ease;
    z-index: 99999;
    pointer-events: none;
}
#fyncall-widget-container.fyncall-blur-active::before {
    opacity: 1;
    visibility: visible;
}
` : ''}

/* Header */
#fyncall-header {
    background: ${config.headerImageUrl ?
      `url('${config.headerImageUrl}') center/cover no-repeat` :
      config.gradientEnabled ?
        `linear-gradient(135deg, ${config.gradientColors[0] || 'var(--fyncall-primary)'} 0%, ${config.gradientColors[1] || 'var(--fyncall-primary)'} 100%)` :
        'linear-gradient(135deg, var(--fyncall-primary) 0%, color-mix(in srgb, var(--fyncall-primary) 80%, #000) 100%)'};
    color: white;
    padding: 12px 16px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 12px;
    position: relative;
}
${config.headerImageUrl ? `
#fyncall-header::before {
    content: '';
    position: absolute;
    inset: 0;
    background: rgba(0, 0, 0, 0.3);
    z-index: 0;
}
#fyncall-header > * {
    position: relative;
    z-index: 1;
}
` : ''}
#fyncall-header-info { display: flex; align-items: center; gap: 12px; flex: 1; min-width: 0; }
.fyncall-header-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: white;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    font-weight: 700;
    color: var(--fyncall-primary);
    flex-shrink: 0;
    border: 2px solid rgba(255,255,255,0.3);
    overflow: hidden;
}
.fyncall-header-avatar img { width: 100%; height: 100%; object-fit: cover; }
#fyncall-header-text { flex: 1; min-width: 0; color: white; }
#fyncall-header-text h3 { margin: 0; font-size: 14px; font-weight: 600; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; color: white !important; }
#fyncall-header-text p { margin: 2px 0 0; font-size: 12px; opacity: 0.85; display: flex; align-items: center; gap: 6px; color: rgba(255,255,255,0.9) !important; }
.fyncall-online-dot {
    width: 8px;
    height: 8px;
    background: #4ade80;
    border-radius: 50%;
    display: inline-block;
    flex-shrink: 0;
}
.fyncall-header-action {
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    width: 28px;
    height: 28px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    opacity: 0.8;
    transition: all 0.2s;
    padding: 0;
}
.fyncall-header-action:hover { opacity: 1; background: rgba(255,255,255,0.1); }
.fyncall-header-action svg { width: 16px; height: 16px; stroke: currentColor; fill: none; }
.fyncall-header-actions { display: flex; align-items: center; gap: 2px; }

/* Header Menu Dropdown */
.fyncall-header-menu {
    position: relative;
}
.fyncall-header-menu-dropdown {
    position: absolute;
    top: 100%;
    right: 0;
    margin-top: 8px;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    min-width: 180px;
    z-index: 1000;
    opacity: 0;
    visibility: hidden;
    transform: translateY(-10px);
    transition: all 0.2s ease;
    overflow: hidden;
}
.fyncall-header-menu-dropdown.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}
.fyncall-menu-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 12px 16px;
    font-size: 14px;
    color: #374151;
    cursor: pointer;
    transition: background 0.15s;
    border: none;
    background: none;
    width: 100%;
    text-align: left;
}
.fyncall-menu-item:hover {
    background: #f3f4f6;
}
.fyncall-menu-item svg {
    width: 16px;
    height: 16px;
    stroke: currentColor;
    fill: none;
    flex-shrink: 0;
}
.fyncall-menu-item.danger {
    color: #dc2626;
}
.fyncall-menu-item.danger:hover {
    background: #fef2f2;
}
.fyncall-menu-divider {
    height: 1px;
    background: #e5e7eb;
    margin: 4px 0;
}

/* Status Bar */
#fyncall-status { padding: 8px 16px; text-align: center; font-size: 12px; background: #fff3cd; color: #856404; display: none; }
#fyncall-status.show { display: block; }
#fyncall-status.error { background: #f8d7da; color: #721c24; }
#fyncall-status.success { background: #d4edda; color: #155724; }

/* Messages Container */
#fyncall-messages {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
    background: linear-gradient(180deg, #f8fafc 0%, #ffffff 100%);
    scroll-behavior: smooth;
}

/* Date Separator */
.fyncall-date-separator {
    display: flex;
    justify-content: center;
    margin: 16px 0;
}
.fyncall-date-separator span {
    font-size: 12px;
    color: #64748b;
    background: white;
    padding: 6px 16px;
    border-radius: 100px;
    box-shadow: 0 1px 2px rgba(0,0,0,0.05);
    border: 1px solid #f1f5f9;
}

/* Message Bubble */
.fyncall-message {
    margin-bottom: 16px;
    animation: ${config.animationStyle === 'none' || !config.messageAnimations ? 'none' :
      config.animationStyle === 'standard' ? 'fyncall-slideIn 0.3s ease' :
        'fyncall-fadeIn 0.2s ease'};
    display: flex;
    gap: 8px;
    align-items: flex-start;
}
@keyframes fyncall-fadeIn {
    from { opacity: 0; transform: translateY(5px); }
    to { opacity: 1; transform: translateY(0); }
}
@keyframes fyncall-slideIn {
    from { opacity: 0; transform: translateX(-10px) translateY(10px); }
    to { opacity: 1; transform: translateX(0) translateY(0); }
}
.fyncall-message.visitor {
    animation: ${config.animationStyle === 'none' || !config.messageAnimations ? 'none' :
      config.animationStyle === 'standard' ? 'fyncall-slideInRight 0.3s ease' :
        'fyncall-fadeIn 0.2s ease'};
}
@keyframes fyncall-slideInRight {
    from { opacity: 0; transform: translateX(10px) translateY(10px); }
    to { opacity: 1; transform: translateX(0) translateY(0); }
}
.fyncall-message.visitor { justify-content: flex-end; }
.fyncall-message.bot {
    align-items: flex-start;
    column-gap: 12px;
    row-gap: 4px;
    display: grid;
    grid-template-columns: min-content 1fr;
}

/* Message Avatar - inline with agent name for bot messages */
.fyncall-msg-avatar {
    grid-row: 1/3;
    width: 28px;
    height: 28px;
    min-width: 28px;
    border-radius: 50%;
    background: var(--fyncall-primary-light);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    flex-shrink: 0;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.fyncall-msg-avatar img {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    object-fit: cover;
}

/* Bot message header (avatar + name inline) */
.fyncall-bot-header {
    display: flex;
    align-items: center;
    gap: 8px;
}

/* Grouped Messages - hide avatar/name for consecutive messages from same sender */
.fyncall-message.fyncall-grouped {
    margin-top: -10px;
}
.fyncall-message.fyncall-grouped .fyncall-bot-header {
    display: none;
}
.fyncall-message.fyncall-grouped .fyncall-msg-avatar {
    visibility: hidden;
    width: 0;
    min-width: 0;
}

/* Message Wrapper (contains name, bubble, time) */
.fyncall-message-wrapper {
    display: flex;
    flex-direction: column;
    gap: 4px;
    max-width: 90%;
    width: 90%;
}
.fyncall-message.visitor .fyncall-message-wrapper {
    align-items: flex-end;
    max-width: 85%;
    width: auto;
}
.fyncall-message.bot .fyncall-message-wrapper { 
    align-items: flex-start; 
    grid-column-start: 2;
}

/* Agent Name */
.fyncall-agent-name {
    font-size: 13px;
    font-weight: 600;
    color: #374151;
}

.fyncall-message-content {
    padding: 12px 16px;
    font-size: ${config.messageStyling?.message_font_size === 'small' ? '13px' : config.messageStyling?.message_font_size === 'large' ? '16px' : '14px'};
    line-height: 1.5;
    position: relative;
    max-width: 100%;
}

/* Message Bubble Styles (Phase 2) */
/* Default rounded style - flat corner at top where avatar connects */
.fyncall-message-content { border-radius: 16px; }
.fyncall-message.visitor .fyncall-message-content { border-top-right-radius: 4px; }
.fyncall-message.bot .fyncall-message-content { border-top-left-radius: 4px; }

/* Sharp style */
#fyncall-widget-container[data-bubble-style="sharp"] .fyncall-message-content { border-radius: 0; }
#fyncall-widget-container[data-bubble-style="sharp"] .fyncall-message.visitor .fyncall-message-content { border-radius: 0; }
#fyncall-widget-container[data-bubble-style="sharp"] .fyncall-message.bot .fyncall-message-content { border-radius: 0; }

/* Modern style */
#fyncall-widget-container[data-bubble-style="modern"] .fyncall-message-content { border-radius: 16px; }
#fyncall-widget-container[data-bubble-style="modern"] .fyncall-message.visitor .fyncall-message-content { border-radius: 16px 4px 16px 16px; }
#fyncall-widget-container[data-bubble-style="modern"] .fyncall-message.bot .fyncall-message-content { border-radius: 4px 16px 16px 16px; }

/* Minimal style */
#fyncall-widget-container[data-bubble-style="minimal"] .fyncall-message-content { border-radius: 8px; }

.fyncall-message.visitor .fyncall-message-content {
    background: ${config.messageStyling?.user_bubble_color || 'var(--fyncall-primary)'};
    color: white;
}
.fyncall-message.bot .fyncall-message-content {
    background: ${config.messageStyling?.agent_bubble_color || 'white'};
    color: var(--fyncall-text);
    border: 1px solid #e2e8f0;
}
.fyncall-message-time {
    font-size: 10px;
    color: var(--fyncall-text-light);
    margin-top: 4px;
    margin-left: 4px;
    display: ${config.messageStyling?.show_timestamps === false ? 'none' : 'flex'};
    align-items: center;
    gap: 4px;
    opacity: ${config.timestampOnHover || config.messageStyling?.timestamp_on_hover ? '0' : '1'};
    transition: opacity 0.2s;
}
.fyncall-message:hover .fyncall-message-time { opacity: 1; }
.fyncall-message.visitor .fyncall-message-time { justify-content: flex-end; }

/* Read Receipt */
.fyncall-read-receipt {
    display: inline-flex;
    align-items: center;
    vertical-align: middle;
    margin-left: 4px;
}
.fyncall-read-receipt svg {
    width: 14px;
    height: 14px;
}
.fyncall-read-receipt.sent { color: var(--fyncall-text-light); }
.fyncall-read-receipt.delivered { color: var(--fyncall-primary); }
.fyncall-read-receipt.read { color: var(--fyncall-primary); }

/* Read Receipt Text Style */
${config.readReceiptsStyle === 'text' ? `
.fyncall-read-receipt::before { content: none; }
.fyncall-read-receipt.sent::after { content: 'Sent'; font-size: 9px; }
.fyncall-read-receipt.delivered::after { content: 'Delivered'; font-size: 9px; }
.fyncall-read-receipt.read::after { content: 'Read'; font-size: 9px; }
.fyncall-read-receipt svg { display: none; }
` : ''}

/* Message Reactions - WhatsApp Style */
.fyncall-message {
    position: relative;
}
.fyncall-reaction-trigger {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    opacity: 0;
    transition: opacity 0.2s;
    background: var(--fyncall-bg);
    border: 1px solid var(--fyncall-border);
    border-radius: 50%;
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    z-index: 10;
}
.fyncall-message.bot .fyncall-reaction-trigger { right: -36px; }
.fyncall-message.visitor .fyncall-reaction-trigger { left: -36px; }
.fyncall-message:hover .fyncall-reaction-trigger { opacity: 1; }
.fyncall-reaction-trigger:hover { background: var(--fyncall-primary-light); }

.fyncall-reaction-picker {
    position: absolute;
    top: -45px;
    display: none;
    background: white;
    border-radius: 24px;
    padding: 6px 10px;
    box-shadow: 0 4px 16px rgba(0,0,0,0.15);
    gap: 4px;
    z-index: 100;
}
.fyncall-message.bot .fyncall-reaction-picker { left: 0; }
.fyncall-message.visitor .fyncall-reaction-picker { right: 0; }
.fyncall-reaction-picker.show { display: flex; }
.fyncall-reaction-btn {
    background: transparent;
    border: none;
    border-radius: 50%;
    width: 32px;
    height: 32px;
    font-size: 18px;
    cursor: pointer;
    transition: all 0.15s;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-reaction-btn:hover { background: var(--fyncall-primary-light); transform: scale(1.2); }

.fyncall-message-reaction {
    position: absolute;
    bottom: -8px;
    background: white;
    border-radius: 12px;
    padding: 2px 6px;
    font-size: 14px;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    border: 1px solid var(--fyncall-border);
    cursor: pointer;
}
.fyncall-message.bot .fyncall-message-reaction { right: 8px; }
.fyncall-message.visitor .fyncall-message-reaction { left: 8px; }

/* Typing Indicator */
.fyncall-typing {
    display: none;
    padding: 12px 16px;
    background: white;
    border-radius: 16px;
    width: fit-content;
    margin-bottom: 12px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.08);
}
.fyncall-typing.show { display: flex; align-items: center; gap: 8px; }
.fyncall-typing-dots { display: flex; gap: 4px; }
.fyncall-typing-dots span {
    display: inline-block;
    width: 8px;
    height: 8px;
    background: var(--fyncall-primary);
    border-radius: 50%;
    animation: fyncall-bounce 1.4s infinite;
}
.fyncall-typing-dots span:nth-child(2) { animation-delay: 0.2s; }
.fyncall-typing-dots span:nth-child(3) { animation-delay: 0.4s; }
.fyncall-typing-text { font-size: 12px; color: var(--fyncall-text-light); white-space: nowrap; }
@keyframes fyncall-bounce {
    0%, 60%, 100% { transform: translateY(0); }
    30% { transform: translateY(-4px); }
}

/* Product Carousel */
.fyncall-carousel-container {
    margin-top: 12px;
    position: relative;
}
.fyncall-carousel {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    scrollbar-width: none;
    padding: 4px 0;
}
.fyncall-carousel::-webkit-scrollbar { display: none; }
.fyncall-carousel-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    background: white;
    border: 1px solid var(--fyncall-border);
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(0,0,0,0.1);
    z-index: 2;
    transition: all 0.2s;
}
.fyncall-carousel-nav:hover { background: var(--fyncall-primary); color: white; border-color: var(--fyncall-primary); }
.fyncall-carousel-nav.prev { left: -10px; }
.fyncall-carousel-nav.next { right: -10px; }
.fyncall-carousel-nav svg { width: 14px; height: 14px; }

/* ========== PRODUCT LIST (Minimalist) ========== */
.fyncall-product-list {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
}
.fyncall-product-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: white;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s ease;
    border: 1px solid #f1f5f9;
}
.fyncall-product-item:hover {
    background: #fafafa;
    border-color: #e2e8f0;
    transform: translateX(2px);
}
.fyncall-product-item:active {
    transform: translateX(0);
    background: #f5f5f5;
}
.fyncall-product-item-image {
    width: 44px;
    height: 44px;
    border-radius: 8px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    flex-shrink: 0;
    overflow: hidden;
}
.fyncall-product-item-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-product-item-info {
    flex: 1;
    min-width: 0;
}
.fyncall-product-item-name {
    font-weight: 500;
    font-size: 13px;
    color: #1e293b;
    line-height: 1.3;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.fyncall-product-item-price {
    font-size: 14px;
    font-weight: 600;
    color: var(--fyncall-primary);
    margin-top: 2px;
}
.fyncall-product-item-actions {
    display: flex;
    gap: 6px;
    flex-shrink: 0;
}
.fyncall-product-btn {
    width: 32px;
    height: 32px;
    border-radius: 8px;
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
}
.fyncall-product-btn svg {
    width: 16px;
    height: 16px;
}
.fyncall-product-btn.view {
    background: #f1f5f9;
    color: #64748b;
}
.fyncall-product-btn.view:hover {
    background: #e2e8f0;
    color: #475569;
}
.fyncall-product-btn.cart {
    background: var(--fyncall-primary);
    color: white;
}
.fyncall-product-btn.cart:hover {
    filter: brightness(1.1);
    transform: scale(1.05);
}
.fyncall-product-btn.cart:active {
    transform: scale(0.95);
}
.fyncall-product-view-all {
    color: var(--fyncall-primary);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    text-align: center;
    padding: 8px 0 4px;
    opacity: 0.8;
    transition: opacity 0.15s;
}
.fyncall-product-view-all:hover {
    opacity: 1;
    text-decoration: underline;
}

/* ========== PRODUCT CAROUSEL v2 (Large Image Cards) ========== */
.fyncall-product-carousel-wrapper {
    position: relative;
    margin-top: 12px;
    padding: 0 4px;
}
.fyncall-product-carousel {
    display: flex;
    gap: 10px;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    scrollbar-width: none;
    -ms-overflow-style: none;
    padding: 4px 0 8px;
}
.fyncall-product-carousel::-webkit-scrollbar {
    display: none;
}
.fyncall-product-card-v2 {
    flex: 0 0 140px;
    min-width: 140px;
    scroll-snap-align: start;
    background: white;
    border: 1px solid var(--fyncall-border);
    border-radius: 12px;
    overflow: hidden;
    cursor: pointer;
    transition: all 0.2s ease;
    display: flex;
    flex-direction: column;
}
.fyncall-product-card-v2:hover {
    border-color: var(--fyncall-primary);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.fyncall-product-card-image {
    width: 100%;
    height: 120px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.fyncall-product-card-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-product-card-placeholder {
    font-size: 32px;
    color: #cbd5e1;
}
.fyncall-product-card-footer {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 10px;
    gap: 6px;
    border-bottom: 1px solid #f1f5f9;
}
.fyncall-product-card-name {
    flex: 1;
    font-size: 13px;
    font-weight: 500;
    color: #1e293b;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    line-height: 1.3;
}
.fyncall-product-card-price {
    font-size: 14px;
    font-weight: 700;
    color: var(--fyncall-primary);
    white-space: nowrap;
}
.fyncall-product-card-btn {
    width: 100%;
    padding: 10px 8px;
    border: none;
    background: var(--fyncall-primary);
    color: white;
    font-size: 12px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.15s ease;
}
.fyncall-product-card-btn:hover:not(:disabled) {
    filter: brightness(1.1);
}
.fyncall-product-card-btn:active:not(:disabled) {
    transform: scale(0.98);
}
.fyncall-product-card-btn.added {
    background: #22c55e;
}
.fyncall-product-card-btn.disabled,
.fyncall-product-card-btn:disabled {
    background: #94a3b8;
    cursor: not-allowed;
    opacity: 0.7;
}
.fyncall-carousel-arrow {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1px solid var(--fyncall-border);
    background: white;
    color: #64748b;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.15s ease;
    z-index: 2;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.fyncall-carousel-arrow:hover {
    background: var(--fyncall-primary);
    color: white;
    border-color: var(--fyncall-primary);
}
.fyncall-carousel-arrow svg {
    width: 14px;
    height: 14px;
}
.fyncall-carousel-arrow-left {
    left: -6px;
}
.fyncall-carousel-arrow-right {
    right: -6px;
}
.fyncall-product-carousel-view-all {
    color: var(--fyncall-primary);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    text-align: center;
    padding: 8px 0 4px;
    opacity: 0.8;
    transition: opacity 0.15s;
}
.fyncall-product-carousel-view-all:hover {
    opacity: 1;
    text-decoration: underline;
}

/* Dark mode support for Product Carousel v2 */
#fyncall-widget-container[data-theme="dark"] .fyncall-product-card-v2 {
    background: var(--fyncall-white);
    border-color: var(--fyncall-border);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-product-card-image {
    background: #374151;
}
#fyncall-widget-container[data-theme="dark"] .fyncall-product-card-placeholder {
    color: #6b7280;
}
#fyncall-widget-container[data-theme="dark"] .fyncall-product-card-footer {
    border-color: var(--fyncall-border);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-product-card-name {
    color: var(--fyncall-text);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-carousel-arrow {
    background: var(--fyncall-white);
    border-color: var(--fyncall-border);
    color: var(--fyncall-text-light);
}
#fyncall-widget-container[data-theme="dark"] .fyncall-carousel-arrow:hover {
    background: var(--fyncall-primary);
    color: white;
    border-color: var(--fyncall-primary);
}

/* Rich message only (continuation of previous message - no header) */
.fyncall-message.rich-message-only .fyncall-bot-header {
    display: none;
}
.fyncall-message.rich-message-only {
    margin-top: -8px;
}
.fyncall-message.rich-message-only .fyncall-message-content {
    background: transparent;
    padding: 0;
    box-shadow: none;
}
.fyncall-message.rich-message-only .fyncall-message-wrapper {
    padding-left: 0;
}

/* Product Card (legacy carousel cards) */
.fyncall-product-card {
    flex: 0 0 140px;
    scroll-snap-align: start;
    background: white;
    border: 1px solid var(--fyncall-border);
    border-radius: 12px;
    padding: 10px;
    cursor: pointer;
    transition: all 0.2s ease;
    position: relative;
}
.fyncall-product-card:hover {
    border-color: var(--fyncall-primary);
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
.fyncall-product-image {
    width: 100%;
    height: 80px;
    background: var(--fyncall-bg);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 8px;
    overflow: hidden;
}
.fyncall-product-image img { width: 100%; height: 100%; object-fit: cover; }
.fyncall-product-image-placeholder { color: var(--fyncall-text-light); font-size: 24px; }
.fyncall-product-info { text-align: left; }
.fyncall-product-name {
    font-size: 12px;
    font-weight: 500;
    color: var(--fyncall-text);
    line-height: 1.3;
    margin-bottom: 4px;
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
}
.fyncall-product-brand {
    font-size: 10px;
    color: var(--fyncall-text-light);
    margin-bottom: 4px;
}
.fyncall-product-price {
    font-size: 13px;
    font-weight: 600;
    color: var(--fyncall-primary);
}
.fyncall-product-stock {
    font-size: 9px;
    color: var(--fyncall-warning);
    background: #fff3cd;
    padding: 2px 6px;
    border-radius: 4px;
    margin-top: 4px;
    display: inline-block;
}
/* Product Card Action Buttons */
.fyncall-product-actions {
    display: flex;
    gap: 6px;
    margin-top: 8px;
}
.fyncall-product-btn {
    flex: 1;
    padding: 6px 8px;
    border-radius: 6px;
    font-size: 11px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}
.fyncall-product-btn svg { width: 12px; height: 12px; }
.fyncall-product-btn.primary {
    background: var(--fyncall-primary);
    color: white;
    border: none;
}
.fyncall-product-btn.primary:hover { opacity: 0.9; transform: translateY(-1px); }
.fyncall-product-btn.secondary {
    background: transparent;
    color: var(--fyncall-primary);
    border: 1px solid var(--fyncall-primary);
}
.fyncall-product-btn.secondary:hover { background: var(--fyncall-primary-light); }
.fyncall-product-btn.added {
    background: var(--fyncall-success);
    border-color: var(--fyncall-success);
    color: white;
}
.fyncall-product-btn:disabled { opacity: 0.6; cursor: not-allowed; }

/* Variant Badge */
.fyncall-product-variants-badge {
    font-size: 9px;
    color: var(--fyncall-text-light);
    background: var(--fyncall-bg);
    padding: 2px 6px;
    border-radius: 4px;
    margin-top: 4px;
    display: inline-block;
}

/* Variant Selection Modal */
.fyncall-modal-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,0.5);
    display: none;
    align-items: center;
    justify-content: center;
    z-index: 10001;
    animation: fyncall-fadeIn 0.2s ease;
}
.fyncall-modal-overlay.show { display: flex; }
.fyncall-modal {
    background: white;
    border-radius: 16px;
    max-width: 340px;
    width: 90%;
    max-height: 80vh;
    overflow: hidden;
    box-shadow: 0 10px 40px rgba(0,0,0,0.2);
    animation: fyncall-slideUp 0.3s ease;
}
.fyncall-modal-header {
    padding: 16px;
    border-bottom: 1px solid var(--fyncall-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.fyncall-modal-title { font-size: 16px; font-weight: 600; margin: 0; }
.fyncall-modal-close {
    background: none;
    border: none;
    font-size: 24px;
    cursor: pointer;
    color: var(--fyncall-text-light);
    line-height: 1;
}
.fyncall-modal-body {
    padding: 16px;
    overflow-y: auto;
    max-height: calc(80vh - 140px);
}
.fyncall-modal-footer {
    padding: 16px;
    border-top: 1px solid var(--fyncall-border);
    display: flex;
    gap: 10px;
}
.fyncall-modal-footer .fyncall-product-btn { flex: 1; padding: 10px; font-size: 13px; }

/* End Chat Card (in chat area) */
.fyncall-end-chat-card {
    background: white;
    border-radius: 16px;
    padding: 24px;
    margin: 16px;
    text-align: center;
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
    border: 1px solid #e5e7eb;
}
.fyncall-end-chat-card h4 {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin: 0 0 8px 0;
}
.fyncall-end-chat-card p {
    font-size: 14px;
    color: #6b7280;
    margin: 0 0 20px 0;
}

/* End Chat Modal */
.fyncall-end-chat-modal .fyncall-modal {
    text-align: center;
}
.fyncall-end-chat-icon {
    width: 56px;
    height: 56px;
    margin: 0 auto 16px;
    background: linear-gradient(135deg, #10b981 0%, #059669 100%);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-end-chat-icon svg {
    width: 28px;
    height: 28px;
    stroke: white;
    fill: none;
}
.fyncall-end-chat-title {
    font-size: 18px;
    font-weight: 600;
    color: #111827;
    margin-bottom: 8px;
}
.fyncall-end-chat-subtitle {
    font-size: 14px;
    color: #6b7280;
    margin-bottom: 20px;
}
.fyncall-end-chat-actions {
    display: flex;
    flex-direction: column;
    gap: 10px;
}
.fyncall-end-chat-btn {
    padding: 12px 20px;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    border: none;
}
.fyncall-end-chat-btn svg {
    width: 18px;
    height: 18px;
    stroke: currentColor;
    fill: none;
}
.fyncall-end-chat-btn.primary {
    background: var(--fyncall-primary);
    color: white;
}
.fyncall-end-chat-btn.primary:hover {
    opacity: 0.9;
    transform: translateY(-1px);
}
.fyncall-end-chat-btn.secondary {
    background: #f3f4f6;
    color: #374151;
}
.fyncall-end-chat-btn.secondary:hover {
    background: #e5e7eb;
}

/* Variant Product Preview */
.fyncall-variant-preview {
    display: flex;
    gap: 12px;
    margin-bottom: 16px;
    padding-bottom: 16px;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-variant-preview-image {
    width: 80px;
    height: 80px;
    border-radius: 8px;
    background: var(--fyncall-bg);
    overflow: hidden;
    flex-shrink: 0;
}
.fyncall-variant-preview-image img { width: 100%; height: 100%; object-fit: cover; }
.fyncall-variant-preview-info { flex: 1; }
.fyncall-variant-preview-name { font-size: 14px; font-weight: 600; margin-bottom: 4px; }
.fyncall-variant-preview-price { font-size: 16px; font-weight: 700; color: var(--fyncall-primary); }
.fyncall-variant-preview-original {
    font-size: 12px;
    color: var(--fyncall-text-light);
    text-decoration: line-through;
    margin-left: 6px;
}

/* Variant Options */
.fyncall-variant-group { margin-bottom: 16px; }
.fyncall-variant-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--fyncall-text);
    margin-bottom: 8px;
    display: block;
}
.fyncall-variant-options { display: flex; flex-wrap: wrap; gap: 8px; }
.fyncall-variant-option {
    padding: 8px 14px;
    border: 1px solid var(--fyncall-border);
    border-radius: 8px;
    background: white;
    font-size: 13px;
    cursor: pointer;
    transition: all 0.2s;
}
.fyncall-variant-option:hover { border-color: var(--fyncall-primary); }
.fyncall-variant-option.selected {
    border-color: var(--fyncall-primary);
    background: var(--fyncall-primary-light);
    color: var(--fyncall-primary);
    font-weight: 500;
}
.fyncall-variant-option.disabled {
    opacity: 0.4;
    cursor: not-allowed;
    text-decoration: line-through;
}
.fyncall-variant-option.color {
    width: 32px;
    height: 32px;
    padding: 0;
    border-radius: 50%;
    position: relative;
}
.fyncall-variant-option.color.selected::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 14px;
    text-shadow: 0 1px 2px rgba(0,0,0,0.3);
}

/* Quantity Selector */
.fyncall-quantity-selector {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--fyncall-border);
}
.fyncall-quantity-label { font-size: 12px; font-weight: 600; }
.fyncall-quantity-controls {
    display: flex;
    align-items: center;
    border: 1px solid var(--fyncall-border);
    border-radius: 8px;
    overflow: hidden;
}
.fyncall-quantity-btn {
    width: 32px;
    height: 32px;
    background: var(--fyncall-bg);
    border: none;
    cursor: pointer;
    font-size: 16px;
    transition: background 0.2s;
}
.fyncall-quantity-btn:hover { background: var(--fyncall-border); }
.fyncall-quantity-btn:disabled { opacity: 0.4; cursor: not-allowed; }
.fyncall-quantity-value {
    width: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 500;
    border: none;
    background: white;
}

/* Enhanced Variant Modal - Color Swatches */
.fyncall-variant-option.color {
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 50%;
    position: relative;
    border: 2px solid transparent;
    box-shadow: inset 0 0 0 2px white;
    transition: all 0.2s ease;
}
.fyncall-variant-option.color:hover {
    transform: scale(1.1);
}
.fyncall-variant-option.color.selected {
    border-color: var(--fyncall-primary);
    box-shadow: inset 0 0 0 2px white, 0 0 0 2px var(--fyncall-primary);
}
.fyncall-variant-option.color.selected::after {
    content: '✓';
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    color: white;
    font-size: 16px;
    font-weight: bold;
    text-shadow: 0 1px 3px rgba(0,0,0,0.5);
}
.fyncall-variant-option.color.disabled {
    opacity: 0.4;
    cursor: not-allowed;
}
.fyncall-variant-option.color.disabled::before {
    content: '';
    position: absolute;
    top: 50%;
    left: -3px;
    right: -3px;
    height: 2px;
    background: #dc2626;
    transform: rotate(-45deg);
}
.fyncall-variant-option.color.light {
    border: 2px solid #e5e7eb;
}
.fyncall-variant-option.color.light.selected {
    border-color: var(--fyncall-primary);
}

/* Variant Stock Indicator */
.fyncall-variant-stock {
    font-size: 12px;
    margin-top: 8px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.fyncall-variant-stock.in-stock {
    color: #16a34a;
}
.fyncall-variant-stock.low-stock {
    color: #ea580c;
    font-weight: 500;
}
.fyncall-variant-stock.low-stock .stock-dot {
    animation: pulse-stock 1.5s ease infinite;
}
.fyncall-variant-stock.out-of-stock {
    color: #dc2626;
}
.stock-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    display: inline-block;
}
.stock-dot.green { background: #16a34a; }
.stock-dot.orange { background: #ea580c; }
.stock-dot.red { background: #dc2626; }
@keyframes pulse-stock {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.6; transform: scale(0.8); }
}

/* Variant Sale Price Display */
.fyncall-variant-price-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
}
.fyncall-variant-sale-badge {
    background: linear-gradient(135deg, #dc2626, #ef4444);
    color: white;
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 4px;
    text-transform: uppercase;
}
.fyncall-variant-original-price {
    font-size: 13px;
    color: #9ca3af;
    text-decoration: line-through;
}

/* Notify When Available */
.fyncall-notify-available {
    margin-top: 12px;
    padding: 12px;
    background: #fef3c7;
    border: 1px solid #fcd34d;
    border-radius: 8px;
}
.fyncall-notify-available-text {
    font-size: 12px;
    color: #92400e;
    margin-bottom: 8px;
}
.fyncall-notify-available-form {
    display: flex;
    gap: 8px;
}
.fyncall-notify-email {
    flex: 1;
    padding: 8px 10px;
    border: 1px solid #fcd34d;
    border-radius: 6px;
    font-size: 12px;
    background: white;
}
.fyncall-notify-btn {
    padding: 8px 12px;
    background: #f59e0b;
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
    white-space: nowrap;
}
.fyncall-notify-btn:hover {
    background: #d97706;
}
.fyncall-notify-success {
    color: #16a34a;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

/* Variant Selected Summary */
.fyncall-variant-selected-summary {
    font-size: 11px;
    color: var(--fyncall-text-light);
    margin-top: 4px;
}

/* Size Guide Link in Variant Modal */
.fyncall-variant-size-guide {
    font-size: 12px;
    color: var(--fyncall-primary);
    cursor: pointer;
    margin-left: auto;
    text-decoration: underline;
    display: flex;
    align-items: center;
    gap: 4px;
}
.fyncall-variant-size-guide:hover {
    opacity: 0.8;
}

/* Variant Label Row */
.fyncall-variant-label-row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 8px;
}

/* Pre-Chat Form */
.fyncall-prechat {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: linear-gradient(135deg, var(--fyncall-primary) 0%, color-mix(in srgb, var(--fyncall-primary) 80%, #000) 100%);
    display: flex;
    flex-direction: column;
    z-index: 5;
    padding: 24px;
    box-sizing: border-box;
    overflow:auto;
}
.fyncall-prechat.hidden { display: none; }
.fyncall-prechat-header {
    text-align: center;
    color: white;
    margin-bottom: 24px;
}
.fyncall-prechat-header h3 {
    margin: 0 0 8px 0;
    font-size: 20px;
    font-weight: 600;
    color: inherit;
}
.fyncall-prechat-header p {
    margin: 0;
    font-size: 14px;
    opacity: 0.9;
}
.fyncall-prechat-avatar {
    width: 72px;
    height: 72px;
    margin: 0 auto 16px;
    background: rgba(255,255,255,0.2);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 36px;
}
.fyncall-prechat-form {
    flex: 1;
    display: flex;
    flex-direction: column;
    gap: 16px;
    background: white;
    border-radius: 16px;
    padding: 24px;
    box-shadow: 0 4px 24px rgba(0,0,0,0.15);
    margin-inline: -24px;
    margin-bottom: -24px;
}
.fyncall-prechat-field {
    display: flex;
    flex-direction: column;
    gap: 6px;
}
.fyncall-prechat-field label {
    font-size: 12px;
    font-weight: 600;
    color: var(--fyncall-text);
    display: flex;
    align-items: center;
    gap: 4px;
}
.fyncall-prechat-field label .optional {
    font-weight: 400;
    color: var(--fyncall-text-light);
}
.fyncall-prechat-field input {
    padding: 12px 14px;
    border: 1px solid var(--fyncall-border);
    border-radius: 8px;
    font-size: 14px;
    transition: border-color 0.2s, box-shadow 0.2s;
}
.fyncall-prechat-field input:focus {
    outline: none;
    border-color: var(--fyncall-primary);
    box-shadow: 0 0 0 3px var(--fyncall-primary-light);
}
.fyncall-prechat-field input::placeholder {
    color: var(--fyncall-text-light);
}
.fyncall-prechat-actions {
    display: flex;
    flex-direction: column;
    gap: 12px;
    margin-top: auto;
}
.fyncall-prechat-continue {
    padding: 14px 20px;
    background: var(--fyncall-primary);
    color: white;
    border: none;
    border-radius: 8px;
    font-size: 14px;
    font-weight: 600;
    cursor: pointer;
    transition: opacity 0.2s, transform 0.1s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.fyncall-prechat-continue:hover { opacity: 0.9; }
.fyncall-prechat-continue:active { transform: scale(0.98); }
.fyncall-prechat-skip {
    padding: 12px 16px;
    background: transparent;
    color: var(--fyncall-text-light);
    border: none;
    font-size: 14px;
    cursor: pointer;
    transition: color 0.2s;
    text-align: center;
}
.fyncall-prechat-skip:hover { color: var(--fyncall-text); }
.fyncall-prechat-divider {
    display: flex;
    align-items: center;
    gap: 12px;
    color: var(--fyncall-text-light);
    font-size: 12px;
}
.fyncall-prechat-divider::before,
.fyncall-prechat-divider::after {
    content: '';
    flex: 1;
    height: 1px;
    background: var(--fyncall-border);
}

/* Enhanced Pre-chat Form Fields */
.fyncall-prechat-field select,
.fyncall-prechat-field textarea {
    width: 100%;
    padding: 14px 16px;
    border: 1px solid var(--fyncall-border);
    border-radius: 10px;
    font-size: 14px;
    font-family: inherit;
    transition: border-color 0.2s;
    background: var(--fyncall-white);
    resize: vertical;
}
.fyncall-prechat-field select:focus,
.fyncall-prechat-field textarea:focus {
    outline: none;
    border-color: var(--fyncall-primary);
}
.fyncall-prechat-field textarea {
    min-height: 80px;
}
.fyncall-prechat-checkbox {
    display: flex;
    align-items: center;
    gap: 10px;
    margin-top: 8px;
}
.fyncall-prechat-checkbox input[type="checkbox"] {
    width: 18px;
    height: 18px;
    accent-color: var(--fyncall-primary);
}
.fyncall-prechat-checkbox label {
    font-size: 13px;
    color: var(--fyncall-text);
    cursor: pointer;
}
.fyncall-prechat-error {
    color: var(--fyncall-danger);
    font-size: 12px;
    margin-top: 4px;
    display: none;
}
.fyncall-prechat-field.error input,
.fyncall-prechat-field.error select,
.fyncall-prechat-field.error textarea {
    border-color: var(--fyncall-danger);
}
.fyncall-prechat-field.error .fyncall-prechat-error {
    display: block;
}

/* Post-Chat CSAT Survey */
.fyncall-csat {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: white;
    display: none;
    flex-direction: column;
    z-index: 20;
}
.fyncall-csat.show { display: flex; }
.fyncall-csat-header {
    background: var(--fyncall-primary);
    color: white;
    padding: 20px;
    text-align: center;
}
.fyncall-csat-header h3 {
    margin: 0;
    font-size: 18px;
    font-weight: 600;
    color: white;
}
.fyncall-csat-content {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 30px 20px;
    text-align: center;
}
.fyncall-csat-question {
    font-size: 16px;
    font-weight: 500;
    color: var(--fyncall-text);
    margin-bottom: 24px;
}
/* Star Rating */
.fyncall-csat-stars {
    display: flex;
    gap: 8px;
    margin-bottom: 24px;
}
.fyncall-csat-star {
    font-size: 36px;
    cursor: pointer;
    color: #ddd;
    transition: color 0.2s, transform 0.2s;
}
.fyncall-csat-star:hover,
.fyncall-csat-star.active { color: #ffc107; }
.fyncall-csat-star:hover { transform: scale(1.15); }
/* Thumbs Rating */
.fyncall-csat-thumbs {
    display: flex;
    gap: 24px;
    margin-bottom: 24px;
}
.fyncall-csat-thumb {
    width: 64px;
    height: 64px;
    border-radius: 50%;
    border: 2px solid var(--fyncall-border);
    background: white;
    cursor: pointer;
    font-size: 28px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-csat-thumb:hover {
    border-color: var(--fyncall-primary);
    transform: scale(1.1);
}
.fyncall-csat-thumb.active {
    background: var(--fyncall-primary);
    border-color: var(--fyncall-primary);
}
.fyncall-csat-thumb.active.up { background: var(--fyncall-success); border-color: var(--fyncall-success); }
.fyncall-csat-thumb.active.down { background: var(--fyncall-danger); border-color: var(--fyncall-danger); }
/* NPS Rating */
.fyncall-csat-nps {
    display: flex;
    gap: 6px;
    margin-bottom: 24px;
}
.fyncall-csat-nps-btn {
    width: 32px;
    height: 40px;
    border: 1px solid var(--fyncall-border);
    border-radius: 6px;
    background: white;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
    transition: all 0.2s;
}
.fyncall-csat-nps-btn:hover {
    border-color: var(--fyncall-primary);
    background: var(--fyncall-primary-light);
}
.fyncall-csat-nps-btn.active {
    background: var(--fyncall-primary);
    border-color: var(--fyncall-primary);
    color: white;
}
.fyncall-csat-nps-labels {
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin-top: 8px;
    font-size: 11px;
    color: var(--fyncall-text-light);
}
/* Follow-up feedback */
.fyncall-csat-followup {
    width: 100%;
    margin-top: 16px;
}
.fyncall-csat-followup textarea {
    width: 100%;
    padding: 12px;
    border: 1px solid var(--fyncall-border);
    border-radius: 8px;
    font-size: 14px;
    font-family: inherit;
    min-height: 80px;
    resize: none;
}
.fyncall-csat-followup textarea:focus {
    outline: none;
    border-color: var(--fyncall-primary);
}
.fyncall-csat-followup label {
    display: block;
    font-size: 13px;
    color: var(--fyncall-text);
    margin-bottom: 8px;
}
/* CSAT Actions */
.fyncall-csat-actions {
    padding: 16px 20px;
    border-top: 1px solid var(--fyncall-border);
    display: flex;
    gap: 12px;
}
.fyncall-csat-submit {
    flex: 1;
    padding: 14px 20px;
    background: var(--fyncall-primary);
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: opacity 0.2s;
}
.fyncall-csat-submit:hover { opacity: 0.9; }
.fyncall-csat-submit:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}
.fyncall-csat-skip {
    padding: 14px 20px;
    background: transparent;
    color: var(--fyncall-text-light);
    border: none;
    font-size: 14px;
    cursor: pointer;
}
.fyncall-csat-skip:hover { color: var(--fyncall-text); }
/* Thank you state */
.fyncall-csat-thankyou {
    display: none;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
    text-align: center;
}
.fyncall-csat-thankyou.show { display: flex; }
.fyncall-csat-thankyou-icon {
    font-size: 64px;
    margin-bottom: 16px;
}
.fyncall-csat-thankyou h3 {
    font-size: 18px;
    font-weight: 600;
    margin: 0 0 8px;
    color: var(--fyncall-text);
}
.fyncall-csat-thankyou p {
    font-size: 14px;
    color: var(--fyncall-text-light);
    margin: 0;
}

/* Cart Panel */
.fyncall-cart-panel {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 100%;
    background: white;
    transform: translateX(100%);
    transition: transform 0.3s ease;
    display: flex;
    flex-direction: column;
    z-index: 10;
}
.fyncall-cart-panel.open { transform: translateX(0); }
.fyncall-cart-header {
    padding: 16px;
    border-bottom: 1px solid var(--fyncall-border);
    display: flex;
    align-items: center;
    gap: 12px;
}
.fyncall-cart-back {
    background: none;
    border: none;
    cursor: pointer;
    font-size: 20px;
    padding: 4px;
    color: var(--fyncall-text);
}
.fyncall-cart-title { font-size: 16px; font-weight: 600; flex: 1; }
.fyncall-cart-count {
    font-size: 12px;
    background: var(--fyncall-primary);
    color: white;
    padding: 2px 8px;
    border-radius: 10px;
}
.fyncall-cart-items {
    flex: 1;
    overflow-y: auto;
    padding: 16px;
}
.fyncall-cart-empty {
    text-align: center;
    padding: 40px 20px;
    color: var(--fyncall-text-light);
}
.fyncall-cart-empty-icon { font-size: 48px; margin-bottom: 12px; }
.fyncall-cart-empty-text { font-size: 14px; }

/* Cart Item */
.fyncall-cart-item {
    display: flex;
    gap: 12px;
    padding: 12px 0;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-cart-item:last-child { border-bottom: none; }
.fyncall-cart-item-image {
    width: 64px;
    height: 64px;
    border-radius: 8px;
    background: var(--fyncall-bg);
    overflow: hidden;
    flex-shrink: 0;
}
.fyncall-cart-item-image img { width: 100%; height: 100%; object-fit: cover; }
.fyncall-cart-item-info { flex: 1; min-width: 0; }
.fyncall-cart-item-name {
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fyncall-cart-item-variant { font-size: 11px; color: var(--fyncall-text-light); margin-bottom: 6px; }
.fyncall-cart-item-price { font-size: 14px; font-weight: 600; color: var(--fyncall-primary); }
.fyncall-cart-item-actions { display: flex; align-items: center; gap: 8px; margin-top: 6px; }
.fyncall-cart-item-qty {
    display: flex;
    align-items: center;
    border: 1px solid var(--fyncall-border);
    border-radius: 6px;
}
.fyncall-cart-item-qty button {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 14px;
}
.fyncall-cart-item-qty span {
    width: 24px;
    text-align: center;
    font-size: 12px;
}
.fyncall-cart-item-remove {
    background: none;
    border: none;
    color: var(--fyncall-danger);
    cursor: pointer;
    font-size: 14px;
    padding: 4px;
}

/* Cart Footer */
.fyncall-cart-footer {
    padding: 16px;
    border-top: 1px solid var(--fyncall-border);
    background: var(--fyncall-bg);
}
.fyncall-cart-subtotal {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;
}
.fyncall-cart-subtotal-label { font-size: 14px; color: var(--fyncall-text-light); }
.fyncall-cart-subtotal-value { font-size: 18px; font-weight: 700; color: var(--fyncall-text); }
.fyncall-checkout-btn {
    width: 100%;
    padding: 14px;
    background: var(--fyncall-primary);
    color: white;
    border: none;
    border-radius: 10px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
}
.fyncall-checkout-btn:hover { opacity: 0.9; transform: translateY(-1px); }
.fyncall-checkout-btn:disabled { opacity: 0.6; cursor: not-allowed; }
.fyncall-checkout-btn svg { width: 18px; height: 18px; }

/* Enhanced Cart - Promo Code Section */
.fyncall-cart-promo {
    padding: 12px 16px;
    border-top: 1px solid var(--fyncall-border);
    background: #fafafa;
}
.fyncall-cart-promo-toggle {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    color: var(--fyncall-primary);
    cursor: pointer;
    background: none;
    border: none;
    padding: 0;
}
.fyncall-cart-promo-toggle:hover {
    text-decoration: underline;
}
.fyncall-cart-promo-form {
    display: none;
    margin-top: 10px;
}
.fyncall-cart-promo-form.show {
    display: flex;
    gap: 8px;
}
.fyncall-cart-promo-input {
    flex: 1;
    padding: 8px 10px;
    border: 1px solid var(--fyncall-border);
    border-radius: 6px;
    font-size: 12px;
    text-transform: uppercase;
}
.fyncall-cart-promo-input:focus {
    outline: none;
    border-color: var(--fyncall-primary);
}
.fyncall-cart-promo-btn {
    padding: 8px 14px;
    background: var(--fyncall-primary);
    color: white;
    border: none;
    border-radius: 6px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: background 0.2s;
}
.fyncall-cart-promo-btn:hover {
    opacity: 0.9;
}
.fyncall-cart-promo-btn:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}
.fyncall-cart-promo-applied {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-top: 8px;
    padding: 8px 10px;
    background: #dcfce7;
    border-radius: 6px;
    font-size: 12px;
    color: #166534;
}
.fyncall-cart-promo-remove {
    background: none;
    border: none;
    color: #dc2626;
    cursor: pointer;
    font-size: 14px;
}
.fyncall-cart-promo-error {
    margin-top: 6px;
    font-size: 11px;
    color: #dc2626;
}

/* Enhanced Cart - Delivery Estimate */
.fyncall-cart-delivery {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 10px 12px;
    background: #eff6ff;
    border-radius: 8px;
    margin-bottom: 12px;
    font-size: 12px;
    color: #1e40af;
}
.fyncall-cart-delivery-icon {
    font-size: 16px;
}
.fyncall-cart-delivery-text {
    flex: 1;
}
.fyncall-cart-delivery-text strong {
    display: block;
    font-size: 13px;
}

/* Enhanced Cart - Savings Display */
.fyncall-cart-savings {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 8px 12px;
    background: linear-gradient(135deg, #dcfce7, #d1fae5);
    border-radius: 8px;
    margin-bottom: 12px;
    font-size: 13px;
    color: #166534;
}
.fyncall-cart-savings-icon {
    margin-right: 6px;
}
.fyncall-cart-savings-amount {
    font-weight: 600;
}

/* Enhanced Cart - Order Summary */
.fyncall-cart-summary {
    padding: 12px 0;
    border-bottom: 1px solid var(--fyncall-border);
    margin-bottom: 12px;
}
.fyncall-cart-summary-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 6px;
    color: var(--fyncall-text-light);
}
.fyncall-cart-summary-row:last-child {
    margin-bottom: 0;
}
.fyncall-cart-summary-row.discount {
    color: #16a34a;
}
.fyncall-cart-summary-row.total {
    font-size: 15px;
    font-weight: 600;
    color: var(--fyncall-text);
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid var(--fyncall-border);
}

/* Enhanced Cart - Save for Later */
.fyncall-cart-item-save {
    font-size: 11px;
    color: var(--fyncall-primary);
    background: none;
    border: none;
    cursor: pointer;
    padding: 0;
    margin-left: auto;
}
.fyncall-cart-item-save:hover {
    text-decoration: underline;
}

/* Enhanced Cart - Free Shipping Progress */
.fyncall-cart-shipping-progress {
    padding: 10px 16px;
    background: #fef3c7;
    border-bottom: 1px solid #fcd34d;
}
.fyncall-cart-shipping-text {
    font-size: 12px;
    color: #92400e;
    margin-bottom: 6px;
    text-align: center;
}
.fyncall-cart-shipping-text.achieved {
    color: #166534;
    background: #dcfce7;
    padding: 8px;
    border-radius: 6px;
    margin: 0 -16px;
    padding-left: 16px;
    padding-right: 16px;
}
.fyncall-cart-shipping-bar {
    height: 6px;
    background: #fde68a;
    border-radius: 3px;
    overflow: hidden;
}
.fyncall-cart-shipping-fill {
    height: 100%;
    background: linear-gradient(90deg, #f59e0b, #16a34a);
    border-radius: 3px;
    transition: width 0.3s ease;
}

/* Cart Button in Header */
.fyncall-header-cart {
    background: rgba(255,255,255,0.2);
    border: none;
    border-radius: 50%;
    width: 36px;
    height: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    margin-right: 8px;
}
.fyncall-header-cart:hover { background: rgba(255,255,255,0.3); }
.fyncall-header-cart svg { width: 18px; height: 18px; fill: white; }
.fyncall-header-cart-badge {
    position: absolute;
    top: -4px;
    right: -4px;
    background: var(--fyncall-danger);
    color: white;
    font-size: 10px;
    font-weight: 600;
    min-width: 16px;
    height: 16px;
    border-radius: 8px;
    display: none;
    align-items: center;
    justify-content: center;
}
.fyncall-header-cart-badge.show { display: flex; }

/* Quick Reply Buttons */
.fyncall-quick-replies {
    display: flex;
    flex-wrap: wrap;
    gap: 8px;
    margin-top: 8px;
}
.fyncall-quick-reply {
    background: color-mix(in srgb, var(--fyncall-primary) 8%, transparent);
    border: 2px solid var(--fyncall-primary);
    color: var(--fyncall-primary);
    padding: 6px 12px;
    border-radius: 100px;
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    gap: 6px;
}
.fyncall-quick-reply:hover {
    background: var(--fyncall-primary);
    color: white;
    transform: scale(1.05);
}
.fyncall-quick-reply svg { width: 14px; height: 14px; }

/* Order Status Card */
.fyncall-order-card {
    background: white;
    border: 1px solid var(--fyncall-border);
    border-radius: 12px;
    padding: 16px;
    margin-top: 12px;
}
.fyncall-order-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 12px;
}
.fyncall-order-id { font-size: 12px; color: var(--fyncall-text-light); }
.fyncall-order-status {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 12px;
}
.fyncall-order-status.processing { background: #fff3cd; color: #856404; }
.fyncall-order-status.shipped { background: #cce5ff; color: #004085; }
.fyncall-order-status.delivered { background: #d4edda; color: #155724; }
.fyncall-order-status.ordered { background: #e2e3e5; color: #383d41; }
.fyncall-order-status.cancelled { background: #f8d7da; color: #721c24; }

/* Comparison Card */
.fyncall-comparison-card {
    background: white;
    border: 1px solid var(--fyncall-border);
    border-radius: 12px;
    margin-top: 12px;
    overflow: hidden;
}
.fyncall-comparison-header {
    background: var(--fyncall-bg);
    padding: 10px 12px;
    font-size: 13px;
    font-weight: 600;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-comparison-table {
    width: 100%;
    font-size: 12px;
}
.fyncall-comparison-table th,
.fyncall-comparison-table td {
    padding: 10px 12px;
    text-align: left;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-comparison-table th {
    background: var(--fyncall-bg);
    font-weight: 500;
    color: var(--fyncall-text-light);
    width: 80px;
}
.fyncall-comparison-table tr:last-child td,
.fyncall-comparison-table tr:last-child th {
    border-bottom: none;
}
.fyncall-comparison-winner {
    background: var(--fyncall-primary-light) !important;
    color: var(--fyncall-primary);
    font-weight: 600;
}
.fyncall-comparison-value-good { color: var(--fyncall-success); }
.fyncall-comparison-value-bad { color: var(--fyncall-danger); }

/* Info Card */
.fyncall-info-card {
    background: white;
    border: 1px solid var(--fyncall-border);
    border-radius: 12px;
    padding: 14px;
    margin-top: 12px;
}
.fyncall-info-card.tip {
    border-left: 4px solid var(--fyncall-primary);
    background: var(--fyncall-primary-light);
}
.fyncall-info-card.warning {
    border-left: 4px solid var(--fyncall-warning);
    background: #fff8e1;
}
.fyncall-info-card.success {
    border-left: 4px solid var(--fyncall-success);
    background: #e8f5e9;
}
.fyncall-info-card-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
}
.fyncall-info-card-icon {
    font-size: 18px;
}
.fyncall-info-card-title {
    font-size: 13px;
    font-weight: 600;
}
.fyncall-info-card-content {
    font-size: 12px;
    color: var(--fyncall-text);
    line-height: 1.5;
}
.fyncall-info-card-action {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    margin-top: 10px;
    font-size: 12px;
    font-weight: 500;
    color: var(--fyncall-primary);
    cursor: pointer;
}
.fyncall-info-card-action:hover { text-decoration: underline; }

/* Feature List */
.fyncall-feature-list {
    margin-top: 10px;
}
.fyncall-feature-item {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 6px 0;
    font-size: 12px;
}
.fyncall-feature-icon {
    flex-shrink: 0;
    width: 16px;
    height: 16px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-feature-icon.check { color: var(--fyncall-success); }
.fyncall-feature-icon.cross { color: var(--fyncall-danger); }

/* ========== CATEGORY BROWSER (Minimalist) ========== */
.fyncall-category-browser {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-top: 12px;
}
.fyncall-category-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 10px 12px;
    background: white;
    border-radius: 10px;
    cursor: pointer;
    transition: all 0.15s ease;
    border: 1px solid #f1f5f9;
}
.fyncall-category-item:hover {
    background: #fafafa;
    border-color: #e2e8f0;
    transform: translateX(2px);
}
.fyncall-category-item:active {
    transform: translateX(0);
    background: #f5f5f5;
}
.fyncall-category-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #f8fafc;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 18px;
    flex-shrink: 0;
    overflow: hidden;
}
.fyncall-category-icon img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-category-item-info {
    flex: 1;
    min-width: 0;
}
.fyncall-category-item-name {
    font-weight: 500;
    font-size: 13px;
    color: #1e293b;
    line-height: 1.3;
}
.fyncall-category-item-count {
    font-size: 11px;
    color: #94a3b8;
    margin-top: 1px;
}
.fyncall-category-view-all {
    color: var(--fyncall-primary);
    font-size: 12px;
    font-weight: 500;
    cursor: pointer;
    text-align: center;
    padding: 8px 0 4px;
    opacity: 0.8;
    transition: opacity 0.15s;
}
.fyncall-category-view-all:hover {
    opacity: 1;
    text-decoration: underline;
}

/* ========== TICKET STATUS CARD ========== */
.fyncall-ticket-card {
    background: var(--fyncall-bg);
    border-radius: 12px;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid var(--fyncall-border);
}
.fyncall-ticket-header {
    padding: 14px 16px;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-ticket-header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 6px;
}
.fyncall-ticket-id {
    font-weight: 600;
    font-size: 14px;
    color: var(--fyncall-text);
    display: flex;
    align-items: center;
    gap: 6px;
}
.fyncall-ticket-priority {
    font-size: 10px;
    font-weight: 600;
    padding: 2px 8px;
    border-radius: 10px;
    text-transform: uppercase;
}
.fyncall-ticket-priority.low { background: #e0f2fe; color: #0369a1; }
.fyncall-ticket-priority.medium { background: #fef3c7; color: #b45309; }
.fyncall-ticket-priority.high { background: #fee2e2; color: #dc2626; }
.fyncall-ticket-priority.urgent { background: #dc2626; color: white; }
.fyncall-ticket-subject {
    font-size: 13px;
    color: var(--fyncall-text-light);
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fyncall-ticket-body {
    padding: 16px;
}
.fyncall-ticket-status-badge {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    font-size: 13px;
    font-weight: 500;
    margin-bottom: 16px;
}
.fyncall-ticket-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
}
.fyncall-ticket-status-dot.open { background: #3b82f6; }
.fyncall-ticket-status-dot.in_progress { background: #f59e0b; animation: fyncall-pulse 2s infinite; }
.fyncall-ticket-status-dot.pending_review { background: #8b5cf6; }
.fyncall-ticket-status-dot.resolved { background: #22c55e; }
.fyncall-ticket-status-dot.closed { background: #6b7280; }
@keyframes fyncall-pulse {
    0%, 100% { opacity: 1; }
    50% { opacity: 0.5; }
}
.fyncall-ticket-progress {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 16px 0;
}
.fyncall-ticket-progress::before {
    content: '';
    position: absolute;
    top: 10px;
    left: 24px;
    right: 24px;
    height: 2px;
    background: var(--fyncall-border);
}
.fyncall-ticket-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
    flex: 1;
}
.fyncall-ticket-step-icon {
    width: 20px;
    height: 20px;
    border-radius: 50%;
    background: var(--fyncall-border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 10px;
    margin-bottom: 4px;
    border: 2px solid white;
}
.fyncall-ticket-step.completed .fyncall-ticket-step-icon { background: var(--fyncall-success); color: white; }
.fyncall-ticket-step.active .fyncall-ticket-step-icon { background: var(--fyncall-primary); color: white; }
.fyncall-ticket-step-label { font-size: 9px; color: var(--fyncall-text-light); text-align: center; }
.fyncall-ticket-details {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
    margin-top: 12px;
}
.fyncall-ticket-detail {
    font-size: 12px;
    color: var(--fyncall-text-light);
    display: flex;
    align-items: center;
    gap: 6px;
}
.fyncall-ticket-actions {
    padding: 12px 16px;
    border-top: 1px solid var(--fyncall-border);
    display: flex;
    gap: 8px;
}
.fyncall-ticket-btn {
    flex: 1;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}
.fyncall-ticket-btn.primary {
    background: var(--fyncall-primary);
    color: white;
}
.fyncall-ticket-btn.primary:hover { opacity: 0.9; }
.fyncall-ticket-btn.secondary {
    background: var(--fyncall-bg);
    color: var(--fyncall-text);
    border: 1px solid var(--fyncall-border);
}
.fyncall-ticket-btn.secondary:hover { background: #f1f5f9; }

/* ========== PRODUCT DETAIL CARD ========== */
.fyncall-product-detail-card {
    background: white;
    border-radius: 12px;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid var(--fyncall-border);
    box-shadow: 0 2px 8px rgba(0,0,0,0.06);
}
.fyncall-product-detail-gallery {
    position: relative;
    background: #f8fafc;
}
.fyncall-product-detail-image {
    width: 100%;
    height: 200px;
    object-fit: contain;
    display: block;
}
.fyncall-product-detail-image-placeholder {
    width: 100%;
    height: 200px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 48px;
    background: #f1f5f9;
}
.fyncall-gallery-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 28px;
    height: 28px;
    border-radius: 50%;
    background: white;
    border: none;
    box-shadow: 0 2px 8px rgba(0,0,0,0.15);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 2;
}
.fyncall-gallery-nav:hover { background: #f8fafc; }
.fyncall-gallery-nav.prev { left: 8px; }
.fyncall-gallery-nav.next { right: 8px; }
.fyncall-gallery-nav svg { width: 14px; height: 14px; }
.fyncall-gallery-dots {
    position: absolute;
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);
    display: flex;
    gap: 6px;
}
.fyncall-gallery-dot {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: rgba(0,0,0,0.2);
    cursor: pointer;
    transition: all 0.2s;
}
.fyncall-gallery-dot.active { background: var(--fyncall-primary); width: 16px; border-radius: 3px; }
.fyncall-product-detail-badges {
    position: absolute;
    top: 8px;
    left: 8px;
    display: flex;
    flex-direction: column;
    gap: 4px;
}
.fyncall-product-badge {
    padding: 4px 8px;
    font-size: 10px;
    font-weight: 600;
    border-radius: 4px;
    text-transform: uppercase;
}
.fyncall-product-badge.sale { background: #dc2626; color: white; }
.fyncall-product-badge.new { background: #22c55e; color: white; }
.fyncall-product-badge.low-stock { background: #f59e0b; color: white; }
.fyncall-wishlist-btn {
    position: absolute;
    top: 8px;
    right: 8px;
    width: 32px;
    height: 32px;
    border-radius: 50%;
    background: white;
    border: none;
    box-shadow: 0 2px 6px rgba(0,0,0,0.1);
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    transition: all 0.2s;
}
.fyncall-wishlist-btn:hover { color: #ef4444; }
.fyncall-wishlist-btn.active { color: #ef4444; }
.fyncall-wishlist-btn svg { width: 18px; height: 18px; }
.fyncall-product-detail-info {
    padding: 16px;
}
.fyncall-product-detail-brand {
    font-size: 11px;
    font-weight: 500;
    color: var(--fyncall-primary);
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 4px;
}
.fyncall-product-detail-name {
    font-size: 16px;
    font-weight: 600;
    color: var(--fyncall-text);
    margin-bottom: 6px;
    line-height: 1.3;
}
.fyncall-product-detail-rating {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 10px;
}
.fyncall-product-detail-stars {
    color: #fbbf24;
    font-size: 14px;
}
.fyncall-product-detail-reviews {
    font-size: 12px;
    color: var(--fyncall-text-light);
}
.fyncall-product-detail-price-row {
    display: flex;
    align-items: baseline;
    gap: 8px;
    margin-bottom: 8px;
}
.fyncall-product-detail-price {
    font-size: 20px;
    font-weight: 700;
    color: var(--fyncall-text);
}
.fyncall-product-detail-compare-price {
    font-size: 14px;
    color: var(--fyncall-text-light);
    text-decoration: line-through;
}
.fyncall-product-detail-discount {
    font-size: 12px;
    font-weight: 600;
    color: #dc2626;
    background: #fee2e2;
    padding: 2px 6px;
    border-radius: 4px;
}
.fyncall-stock-indicator {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 12px;
    margin-bottom: 16px;
}
.fyncall-stock-indicator.in-stock { color: #22c55e; }
.fyncall-stock-indicator.low-stock { color: #f59e0b; }
.fyncall-stock-indicator.out-of-stock { color: #dc2626; }
.fyncall-product-detail-options {
    border-top: 1px solid var(--fyncall-border);
    padding-top: 16px;
}
.fyncall-option-group {
    margin-bottom: 14px;
}
.fyncall-option-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--fyncall-text);
    margin-bottom: 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
}
.fyncall-option-selected {
    font-weight: 400;
    color: var(--fyncall-text-light);
}
.fyncall-option-buttons {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}
.fyncall-option-btn {
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 500;
    border: 1px solid var(--fyncall-border);
    border-radius: 6px;
    background: white;
    cursor: pointer;
    transition: all 0.2s;
    color: var(--fyncall-text);
}
.fyncall-option-btn:hover:not(:disabled) { border-color: var(--fyncall-primary); }
.fyncall-option-btn.selected {
    border-color: var(--fyncall-primary);
    background: var(--fyncall-primary);
    color: white;
}
.fyncall-option-btn:disabled {
    opacity: 0.4;
    cursor: not-allowed;
    text-decoration: line-through;
}
.fyncall-color-options {
    display: flex;
    gap: 8px;
}
.fyncall-color-swatch {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 2px solid var(--fyncall-border);
    cursor: pointer;
    transition: all 0.2s;
    position: relative;
}
.fyncall-color-swatch:hover { transform: scale(1.1); }
.fyncall-color-swatch.selected {
    border-color: var(--fyncall-primary);
    box-shadow: 0 0 0 2px var(--fyncall-primary);
}
.fyncall-color-swatch:disabled { opacity: 0.3; cursor: not-allowed; }
.fyncall-color-swatch.unavailable::after {
    content: '';
    position: absolute;
    top: 50%;
    left: -2px;
    right: -2px;
    height: 2px;
    background: #dc2626;
    transform: rotate(-45deg);
}
.fyncall-quantity-row {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-top: 16px;
    padding-top: 16px;
    border-top: 1px solid var(--fyncall-border);
}
.fyncall-quantity-label {
    font-size: 12px;
    font-weight: 600;
    color: var(--fyncall-text);
}
.fyncall-quantity-controls {
    display: flex;
    align-items: center;
    border: 1px solid var(--fyncall-border);
    border-radius: 8px;
    overflow: hidden;
}
.fyncall-qty-btn {
    width: 32px;
    height: 32px;
    border: none;
    background: #f8fafc;
    cursor: pointer;
    font-size: 16px;
    color: var(--fyncall-text);
    transition: all 0.2s;
}
.fyncall-qty-btn:hover:not(:disabled) { background: #e2e8f0; }
.fyncall-qty-btn:disabled { opacity: 0.5; cursor: not-allowed; }
.fyncall-qty-value {
    width: 40px;
    text-align: center;
    font-size: 14px;
    font-weight: 600;
    border-left: 1px solid var(--fyncall-border);
    border-right: 1px solid var(--fyncall-border);
    padding: 6px 0;
}
.fyncall-product-detail-actions {
    padding: 16px;
    border-top: 1px solid var(--fyncall-border);
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px;
}
.fyncall-detail-action-btn {
    padding: 12px 16px;
    font-size: 13px;
    font-weight: 600;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    border: none;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 6px;
}
.fyncall-detail-action-btn.primary {
    background: var(--fyncall-primary);
    color: white;
    grid-column: span 2;
}
.fyncall-detail-action-btn.primary:hover { opacity: 0.9; transform: translateY(-1px); }
.fyncall-detail-action-btn.secondary {
    background: #f1f5f9;
    color: var(--fyncall-text);
}
.fyncall-detail-action-btn.secondary:hover { background: #e2e8f0; }
.fyncall-detail-action-btn svg { width: 16px; height: 16px; }

/* ========== ORDER DETAIL CARD ========== */
.fyncall-order-detail-card {
    background: var(--fyncall-bg);
    border-radius: 12px;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid var(--fyncall-border);
}
.fyncall-order-detail-header {
    padding: 14px 16px;
    background: white;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-order-detail-header-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 4px;
}
.fyncall-order-detail-number {
    font-weight: 600;
    font-size: 15px;
    color: var(--fyncall-text);
    display: flex;
    align-items: center;
    gap: 6px;
}
.fyncall-order-detail-status {
    font-size: 11px;
    font-weight: 600;
    padding: 4px 10px;
    border-radius: 12px;
    text-transform: uppercase;
}
.fyncall-order-detail-status.pending { background: #fef3c7; color: #b45309; }
.fyncall-order-detail-status.confirmed { background: #dbeafe; color: #1d4ed8; }
.fyncall-order-detail-status.processing { background: #e0e7ff; color: #4338ca; }
.fyncall-order-detail-status.shipped { background: #d1fae5; color: #059669; }
.fyncall-order-detail-status.out_for_delivery { background: #fef3c7; color: #b45309; }
.fyncall-order-detail-status.delivered { background: #dcfce7; color: #16a34a; }
.fyncall-order-detail-status.cancelled { background: #fee2e2; color: #dc2626; }
.fyncall-order-detail-tracking {
    padding: 14px 16px;
    background: #f8fafc;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-order-detail-tracking-info {
    display: flex;
    flex-direction: column;
    gap: 6px;
    margin-bottom: 10px;
    font-size: 12px;
}
.fyncall-order-detail-tracking-row {
    display: flex;
    align-items: center;
    gap: 8px;
    color: var(--fyncall-text-light);
}
.fyncall-order-detail-tracking-row strong {
    color: var(--fyncall-text);
}
.fyncall-track-btn {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 8px 14px;
    font-size: 12px;
    font-weight: 500;
    color: var(--fyncall-primary);
    background: white;
    border: 1px solid var(--fyncall-primary);
    border-radius: 6px;
    cursor: pointer;
    text-decoration: none;
    transition: all 0.2s;
}
.fyncall-track-btn:hover { background: var(--fyncall-primary); color: white; }
.fyncall-order-detail-items {
    padding: 14px 16px;
    background: white;
}
.fyncall-order-detail-items-header {
    font-size: 13px;
    font-weight: 600;
    color: var(--fyncall-text);
    margin-bottom: 12px;
}
.fyncall-order-item {
    display: flex;
    gap: 12px;
    padding: 10px 0;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-order-item:last-child { border-bottom: none; }
.fyncall-order-item-image {
    width: 50px;
    height: 50px;
    border-radius: 8px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
    overflow: hidden;
}
.fyncall-order-item-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-order-item-info {
    flex: 1;
    min-width: 0;
}
.fyncall-order-item-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--fyncall-text);
    margin-bottom: 2px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.fyncall-order-item-variant {
    font-size: 11px;
    color: var(--fyncall-text-light);
    margin-bottom: 4px;
}
.fyncall-order-item-qty-price {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
}
.fyncall-order-item-qty { color: var(--fyncall-text-light); }
.fyncall-order-item-price { font-weight: 600; color: var(--fyncall-text); }
.fyncall-order-detail-totals {
    padding: 14px 16px;
    background: #f8fafc;
    border-top: 1px solid var(--fyncall-border);
}
.fyncall-order-total-row {
    display: flex;
    justify-content: space-between;
    font-size: 12px;
    margin-bottom: 6px;
    color: var(--fyncall-text-light);
}
.fyncall-order-total-row.discount { color: #22c55e; }
.fyncall-order-total-row.final {
    font-size: 14px;
    font-weight: 600;
    color: var(--fyncall-text);
    padding-top: 8px;
    margin-top: 8px;
    border-top: 1px dashed var(--fyncall-border);
}
.fyncall-order-detail-actions {
    padding: 12px 16px;
    background: white;
    border-top: 1px solid var(--fyncall-border);
    display: flex;
    gap: 8px;
}
.fyncall-order-action-btn {
    flex: 1;
    padding: 10px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 8px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid var(--fyncall-border);
    background: white;
    color: var(--fyncall-text);
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
}
.fyncall-order-action-btn:hover { background: #f8fafc; border-color: var(--fyncall-primary); }

/* ========== ENHANCED ORDER CARD STYLES ========== */
.fyncall-order-detail-date {
    font-size: 11px;
    color: var(--fyncall-text-light);
    margin-top: 4px;
}
/* Order Progress Tracker */
.fyncall-order-progress {
    padding: 16px;
    background: #f8fafc;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-order-progress-track {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}
.fyncall-order-progress-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    flex: 0 0 auto;
    position: relative;
    z-index: 1;
}
.fyncall-order-progress-dot {
    width: 12px;
    height: 12px;
    border-radius: 50%;
    background: #d1d5db;
    border: 2px solid #d1d5db;
    transition: all 0.3s;
}
.fyncall-order-progress-step.active .fyncall-order-progress-dot {
    background: var(--fyncall-primary);
    border-color: var(--fyncall-primary);
}
.fyncall-order-progress-step.current .fyncall-order-progress-dot {
    background: white;
    border-color: var(--fyncall-primary);
    box-shadow: 0 0 0 3px rgba(var(--fyncall-primary-rgb, 59, 130, 246), 0.2);
}
.fyncall-order-progress-label {
    font-size: 9px;
    color: #9ca3af;
    margin-top: 6px;
    text-align: center;
    max-width: 50px;
}
.fyncall-order-progress-step.active .fyncall-order-progress-label {
    color: var(--fyncall-text);
    font-weight: 500;
}
.fyncall-order-progress-line {
    flex: 1;
    height: 2px;
    background: #d1d5db;
    margin: 5px 4px 0;
}
.fyncall-order-progress-line.active {
    background: var(--fyncall-primary);
}
/* Compact tracking */
.fyncall-tracking-carrier, .fyncall-tracking-eta {
    font-size: 12px;
    color: var(--fyncall-text-light);
    margin-right: 12px;
}
/* Item badge for +N more */
.fyncall-order-item-badge {
    position: absolute;
    bottom: -4px;
    right: -4px;
    background: var(--fyncall-primary);
    color: white;
    font-size: 10px;
    font-weight: 600;
    padding: 2px 6px;
    border-radius: 10px;
    border: 2px solid white;
}
.fyncall-order-item-image {
    position: relative;
}
/* Compact totals */
.fyncall-order-detail-totals.compact {
    padding: 10px 16px;
    background: #f8fafc;
}
.fyncall-order-detail-totals.compact .fyncall-order-total-row.final {
    padding-top: 0;
    border-top: none;
}
/* Primary actions row */
.fyncall-order-primary-actions {
    padding: 12px 16px;
    background: white;
    border-top: 1px solid var(--fyncall-border);
    display: flex;
    gap: 8px;
    align-items: center;
}
.fyncall-order-action-btn.primary {
    flex: 1;
    padding: 10px 16px;
    font-size: 13px;
    font-weight: 600;
    background: var(--fyncall-primary);
    color: white;
    border: none;
}
.fyncall-order-action-btn.primary:hover {
    filter: brightness(1.1);
    background: var(--fyncall-primary);
}
.fyncall-order-action-btn.more {
    flex: 0 0 40px;
    padding: 10px;
    font-size: 18px;
    font-weight: bold;
    background: white;
    border: 1px solid var(--fyncall-border);
}
/* Dropdown menu container */
.fyncall-order-more-container {
    position: relative;
}
.fyncall-order-dropdown {
    position: absolute;
    bottom: 100%;
    right: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0,0,0,0.15);
    border: 1px solid var(--fyncall-border);
    min-width: 220px;
    overflow: hidden;
    opacity: 0;
    visibility: hidden;
    transform: translateY(10px);
    transition: all 0.2s ease;
    z-index: 1000;
    margin-bottom: 8px;
}
.fyncall-order-dropdown.show {
    opacity: 1;
    visibility: visible;
    transform: translateY(0);
}
.fyncall-order-dropdown-item {
    display: flex;
    align-items: center;
    padding: 12px 16px;
    cursor: pointer;
    transition: background 0.15s;
    border-bottom: 1px solid #f1f5f9;
    font-size: 13px;
    color: var(--fyncall-text);
}
.fyncall-order-dropdown-item:last-child {
    border-bottom: none;
}
.fyncall-order-dropdown-item:hover {
    background: #f8fafc;
}
.fyncall-dropdown-icon {
    width: 28px;
    font-size: 16px;
}
.fyncall-dropdown-arrow {
    margin-left: auto;
    color: #9ca3af;
    font-size: 16px;
}

/* ========== QUICK ACTION CARDS ========== */
.fyncall-quick-actions-card {
    background: var(--fyncall-bg);
    border-radius: 12px;
    margin-top: 10px;
    padding: 14px;
    border: 1px solid var(--fyncall-border);
}
.fyncall-quick-actions-title {
    font-size: 13px;
    font-weight: 500;
    color: var(--fyncall-text-light);
    margin-bottom: 12px;
    text-align: center;
}
.fyncall-quick-actions-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
}
.fyncall-quick-action-item {
    background: white;
    border-radius: 10px;
    padding: 14px 12px;
    cursor: pointer;
    transition: all 0.2s;
    border: 1px solid var(--fyncall-border);
    text-align: center;
}
.fyncall-quick-action-item:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    border-color: var(--fyncall-primary);
}
.fyncall-quick-action-icon {
    font-size: 24px;
    margin-bottom: 8px;
}
.fyncall-quick-action-label {
    font-size: 13px;
    font-weight: 600;
    color: var(--fyncall-text);
    margin-bottom: 2px;
}
.fyncall-quick-action-desc {
    font-size: 11px;
    color: var(--fyncall-text-light);
    line-height: 1.3;
}

/* ========== COLLECTION BROWSER ========== */
.fyncall-collection-browser {
    background: var(--fyncall-bg);
    border-radius: 12px;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid var(--fyncall-border);
}
.fyncall-collection-header {
    padding: 12px 16px;
    background: linear-gradient(135deg, #dc2626 0%, #ef4444 100%);
    color: white;
    font-weight: 600;
    font-size: 14px;
    display: flex;
    align-items: center;
    gap: 8px;
}
.fyncall-collection-products {
    display: flex;
    overflow-x: auto;
    scroll-snap-type: x mandatory;
    -webkit-overflow-scrolling: touch;
    padding: 12px;
    gap: 10px;
}
.fyncall-collection-products::-webkit-scrollbar { display: none; }
.fyncall-collection-product {
    flex-shrink: 0;
    width: 120px;
    scroll-snap-align: start;
    background: white;
    border-radius: 10px;
    overflow: hidden;
    border: 1px solid var(--fyncall-border);
    cursor: pointer;
    transition: all 0.2s;
}
.fyncall-collection-product:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(0,0,0,0.1);
}
.fyncall-collection-product-image {
    width: 100%;
    height: 80px;
    background: #f1f5f9;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-collection-product-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-collection-product-info {
    padding: 8px;
}
.fyncall-collection-product-price {
    font-size: 13px;
    font-weight: 600;
    color: var(--fyncall-text);
}
.fyncall-collection-product-original {
    font-size: 11px;
    color: var(--fyncall-text-light);
    text-decoration: line-through;
}
.fyncall-collection-product-discount {
    font-size: 10px;
    font-weight: 600;
    color: #dc2626;
}
.fyncall-collection-footer {
    padding: 10px 16px;
    border-top: 1px solid var(--fyncall-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 12px;
}
.fyncall-collection-count { color: var(--fyncall-text-light); }
.fyncall-collection-view-all {
    color: var(--fyncall-primary);
    font-weight: 500;
    cursor: pointer;
}
.fyncall-collection-view-all:hover { text-decoration: underline; }

/* ========== CART PANEL CARD ========== */
.fyncall-cart-panel-card {
    background: var(--fyncall-bg);
    border-radius: 12px;
    margin-top: 10px;
    overflow: hidden;
    border: 1px solid var(--fyncall-border);
    box-shadow: 0 2px 8px rgba(0,0,0,0.08);
}
.fyncall-cart-panel-empty {
    padding: 30px;
    text-align: center;
}
.fyncall-cart-panel-empty-icon {
    font-size: 48px;
    margin-bottom: 12px;
}
.fyncall-cart-panel-empty-text {
    color: var(--fyncall-text-light);
    margin-bottom: 16px;
}
.fyncall-cart-panel-shop-btn {
    background: var(--fyncall-primary);
    color: white;
    border: none;
    padding: 10px 20px;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 500;
}
.fyncall-cart-panel-header {
    padding: 12px 16px;
    background: #f8fafc;
    border-bottom: 1px solid var(--fyncall-border);
    display: flex;
    justify-content: space-between;
    align-items: center;
}
.fyncall-cart-panel-title {
    font-weight: 600;
    font-size: 14px;
    color: #1e293b;
}
.fyncall-cart-panel-count {
    font-size: 12px;
    color: #64748b;
}
.fyncall-cart-panel-shipping-progress {
    padding: 12px 16px;
    background: #f8fafc;
    border-bottom: 1px solid var(--fyncall-border);
}
.fyncall-cart-panel-shipping-bar {
    height: 6px;
    background: #e2e8f0;
    border-radius: 3px;
    overflow: hidden;
}
.fyncall-cart-panel-shipping-fill {
    height: 100%;
    background: linear-gradient(90deg, #22c55e, #16a34a);
    border-radius: 3px;
    transition: width 0.3s ease;
}
.fyncall-cart-panel-shipping-text {
    font-size: 12px;
    color: var(--fyncall-text-light);
    margin-top: 6px;
    text-align: center;
}
.fyncall-cart-panel-shipping-text.achieved {
    color: #16a34a;
    font-weight: 500;
}
.fyncall-cart-panel-items {
    padding: 8px;
    max-height: 280px;
    overflow-y: auto;
}
.fyncall-cart-panel-item {
    display: flex;
    gap: 10px;
    padding: 10px;
    border-radius: 8px;
    background: #f8fafc;
    margin-bottom: 8px;
    transition: all 0.2s;
}
.fyncall-cart-panel-item:last-child {
    margin-bottom: 0;
}
.fyncall-cart-panel-item.removing {
    opacity: 0.5;
    transform: translateX(-10px);
}
.fyncall-cart-panel-item-image {
    width: 60px;
    height: 60px;
    border-radius: 6px;
    overflow: hidden;
    background: #e2e8f0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.fyncall-cart-panel-item-image img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-cart-panel-item-details {
    flex: 1;
    min-width: 0;
}
.fyncall-cart-panel-item-name {
    font-size: 13px;
    font-weight: 500;
    color: var(--fyncall-text);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.fyncall-cart-panel-item-variant {
    font-size: 11px;
    color: var(--fyncall-text-light);
    margin-top: 2px;
}
.fyncall-cart-panel-item-price {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-top: 4px;
}
.fyncall-cart-panel-item-current {
    font-size: 13px;
    font-weight: 600;
    color: var(--fyncall-text);
}
.fyncall-cart-panel-item-original {
    font-size: 11px;
    color: var(--fyncall-text-light);
    text-decoration: line-through;
}
.fyncall-cart-panel-item-actions {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 4px;
}
.fyncall-cart-panel-quantity {
    display: flex;
    align-items: center;
    gap: 2px;
    background: white;
    border-radius: 6px;
    border: 1px solid var(--fyncall-border);
}
.fyncall-cart-panel-qty-btn {
    width: 24px;
    height: 24px;
    border: none;
    background: transparent;
    cursor: pointer;
    font-size: 14px;
    color: var(--fyncall-text-light);
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-cart-panel-qty-btn:hover {
    color: var(--fyncall-primary);
}
.fyncall-cart-panel-qty-value {
    font-size: 12px;
    font-weight: 500;
    min-width: 20px;
    text-align: center;
}
.fyncall-cart-panel-item-total {
    font-size: 12px;
    font-weight: 600;
    color: var(--fyncall-text);
}
.fyncall-cart-panel-remove {
    background: transparent;
    border: none;
    cursor: pointer;
    font-size: 14px;
    opacity: 0.6;
    padding: 4px;
}
.fyncall-cart-panel-remove:hover {
    opacity: 1;
}
.fyncall-cart-panel-promo {
    padding: 12px 16px;
    border-top: 1px solid var(--fyncall-border);
}
.fyncall-cart-panel-promo-input-wrapper {
    display: flex;
    gap: 8px;
}
.fyncall-cart-panel-promo-input {
    flex: 1;
    padding: 8px 12px;
    border: 1px solid var(--fyncall-border);
    border-radius: 6px;
    font-size: 13px;
}
.fyncall-cart-panel-promo-input:focus {
    outline: none;
    border-color: var(--fyncall-primary);
}
.fyncall-cart-panel-promo-apply {
    padding: 8px 16px;
    background: #f1f5f9;
    border: 1px solid var(--fyncall-border);
    border-radius: 6px;
    cursor: pointer;
    font-size: 13px;
    font-weight: 500;
}
.fyncall-cart-panel-promo-apply:hover {
    background: #e2e8f0;
}
.fyncall-cart-panel-savings {
    padding: 10px 16px;
    background: linear-gradient(135deg, #fef3c7, #fde68a);
    display: flex;
    justify-content: space-between;
    align-items: center;
    font-size: 13px;
}
.fyncall-cart-panel-savings-amount {
    font-weight: 600;
    color: #16a34a;
}
.fyncall-cart-panel-summary {
    padding: 12px 16px;
    border-top: 1px solid var(--fyncall-border);
}
.fyncall-cart-panel-summary-row {
    display: flex;
    justify-content: space-between;
    font-size: 13px;
    margin-bottom: 8px;
    color: var(--fyncall-text-light);
}
.fyncall-cart-panel-summary-row.shipping {
    padding-bottom: 8px;
    border-bottom: 1px dashed var(--fyncall-border);
}
.fyncall-cart-panel-summary-row.total {
    font-weight: 600;
    font-size: 14px;
    color: var(--fyncall-text);
    margin-bottom: 0;
}
.fyncall-cart-panel-total-amount {
    font-size: 16px;
}
.fyncall-cart-panel-actions {
    padding: 12px 16px;
    display: flex;
    gap: 8px;
}
.fyncall-cart-panel-checkout-btn {
    flex: 2;
    padding: 12px;
    background: var(--fyncall-primary);
    color: white;
    border: none;
    border-radius: 8px;
    cursor: pointer;
    font-weight: 600;
    font-size: 14px;
    transition: all 0.2s;
}
.fyncall-cart-panel-checkout-btn:hover {
    filter: brightness(0.9);
    transform: translateY(-1px);
}
.fyncall-cart-panel-continue-btn {
    flex: 1;
    padding: 12px;
    background: #f1f5f9;
    color: var(--fyncall-text);
    border: 1px solid var(--fyncall-border);
    border-radius: 8px;
    cursor: pointer;
    font-size: 13px;
}
.fyncall-cart-panel-continue-btn:hover {
    background: #e2e8f0;
}

/* Toast notifications */
.fyncall-toast-container {
    position: fixed;
    bottom: 100px;
    right: 20px;
    z-index: 10002;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.fyncall-toast {
    padding: 12px 16px;
    border-radius: 8px;
    font-size: 13px;
    color: white;
    box-shadow: 0 4px 12px rgba(0,0,0,0.15);
    animation: slideIn 0.3s ease;
}
.fyncall-toast.info {
    background: #3b82f6;
}
.fyncall-toast.success {
    background: #22c55e;
}
.fyncall-toast.error {
    background: #ef4444;
}
.fyncall-toast.fade-out {
    animation: fadeOut 0.3s ease forwards;
}
@keyframes slideIn {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
}
@keyframes fadeOut {
    from { opacity: 1; }
    to { opacity: 0; }
}

/* Disabled state for cart panel buttons */
.fyncall-cart-panel-qty-btn:disabled {
    opacity: 0.5;
    cursor: not-allowed;
}

.fyncall-order-progress {
    display: flex;
    justify-content: space-between;
    position: relative;
    margin: 16px 0;
}
.fyncall-order-progress::before {
    content: '';
    position: absolute;
    top: 12px;
    left: 20px;
    right: 20px;
    height: 2px;
    background: var(--fyncall-border);
}
.fyncall-order-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    z-index: 1;
}
.fyncall-order-step-icon {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: var(--fyncall-border);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 12px;
    margin-bottom: 4px;
}
.fyncall-order-step.completed .fyncall-order-step-icon { background: var(--fyncall-success); color: white; }
.fyncall-order-step.active .fyncall-order-step-icon { background: var(--fyncall-primary); color: white; }
.fyncall-order-step-label { font-size: 10px; color: var(--fyncall-text-light); }

/* Input Area */
#fyncall-input-area {
    padding: 8px 16px;
    background: white;
    margin-bottom: 2px;
}
.fyncall-input-actions {
    display: flex;
    gap: 4px;
}
/* Input wrapper - contains textarea and attach button */
.fyncall-input-wrapper {
    flex: 1;
    display: flex;
    align-items: center;
    background: white;
    border-radius: 20px;
    padding: 6px 8px 6px 16px;
    border: 1px solid #e2e8f0;
    transition: all 0.2s;
    min-height: 44px;
    box-sizing: border-box;
}
.fyncall-input-wrapper:focus-within {
    border-color: var(--fyncall-primary);
    background: #fff;
}
/* Attach button inside input wrapper */
.fyncall-input-action {
    padding: 4px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    transition: all 0.2s;
    flex-shrink: 0;
    margin-bottom: 0;
}
.fyncall-input-action:hover { background: #e2e8f0; color: var(--fyncall-primary); }
.fyncall-input-action svg { width: 18px; height: 18px; }
/* Textarea input */
#fyncall-input {
    flex: 1;
    padding: 6px 4px;
    border: none;
    background: transparent !important;
    background-color: transparent !important;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    font-size: 14px;
    font-family: inherit;
    line-height: 1.4;
    outline: none !important;
    box-shadow: none !important;
    resize: none;
    max-height: 72px; /* ~3 lines */
    min-height: 20px;
    overflow-y: auto;
    scrollbar-width: thin;
}
#fyncall-input::-webkit-scrollbar {
    width: 4px;
}
#fyncall-input::-webkit-scrollbar-thumb {
    background: #cbd5e1;
    border-radius: 2px;
}
#fyncall-input::placeholder { color: #94a3b8; }
#fyncall-input:focus {
    outline: none !important;
    box-shadow: none !important;
    border: none !important;
    background: transparent !important;
}
.fyncall-emoji-btn {
    width: 28px;
    height: 28px;
    border: none;
    background: transparent;
    border-radius: 6px;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #94a3b8;
    transition: all 0.2s;
    padding: 0;
}
.fyncall-emoji-btn:hover { background: #e2e8f0; }
.fyncall-emoji-btn svg { width: 20px; height: 20px; }
#fyncall-send {
    padding: 8px;
    border-radius: 12px;
    color: var(--fyncall-primary);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: all 0.2s;
    background: transparent;
}
#fyncall-send:hover { transform: scale(1.05); box-shadow: 0 6px 16px rgba(0,0,0,0.2); }
#fyncall-send:disabled { background: #e2e8f0; cursor: not-allowed; box-shadow: none; }
#fyncall-send:disabled svg { fill: #94a3b8; }
#fyncall-send svg { width: 18px; height: 18px;}

/* File Upload Preview */
.fyncall-file-preview {
    display: none;
    padding: 8px 16px;
    background: var(--fyncall-bg);
    border-top: 1px solid var(--fyncall-border);
}
.fyncall-file-preview.show { display: flex; align-items: center; gap: 12px; }
.fyncall-file-preview-thumb {
    width: 48px;
    height: 48px;
    border-radius: 8px;
    object-fit: cover;
}
.fyncall-file-preview-info { flex: 1; }
.fyncall-file-preview-name { font-size: 13px; font-weight: 500; }
.fyncall-file-preview-size { font-size: 11px; color: var(--fyncall-text-light); }
.fyncall-file-preview-remove {
    background: none;
    border: none;
    color: var(--fyncall-danger);
    cursor: pointer;
    font-size: 18px;
}

/* Powered By */
.fyncall-powered {
    text-align: center;
    padding: 8px;
    font-size: 10px;
    color: var(--fyncall-text-light);
    background: var(--fyncall-bg);
}
.fyncall-powered a { color: var(--fyncall-primary); text-decoration: none; }

/* Mobile Responsive */
@media (max-width: 480px) {
    #fyncall-widget-container {
        left: 0 !important;
        right: 0 !important;
        bottom: 0;
    }
    #fyncall-chat-window {
        width: 100%;
        height: 100vh;
        max-height: 100vh;
        border-radius: 0;
        margin-bottom: 0;
    }
    #fyncall-launcher {
        position: fixed;
        right: ${Math.min(config.launcherPositionOffset?.x || 20, 16)}px;
        bottom: ${Math.min(config.launcherPositionOffset?.y || 20, 16)}px;
    }
    .fyncall-proactive {
        right: ${Math.min(config.launcherPositionOffset?.x || 20, 16)}px;
        left: 16px;
        max-width: none;
    }
}

/* File input hidden */
#fyncall-file-input { display: none; }

/* Spin animation for loading */
@keyframes fyncall-spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
}
.spin { animation: fyncall-spin 1s linear infinite; }

/* ========== HOME SCREEN STYLES ========== */
#fyncall-home-screen {
    display: none; /* Hidden by default, shown via .visible class */
    flex-direction: column;
    height: 100%;
    background: white;
}
#fyncall-home-screen.visible { display: flex; }
#fyncall-home-screen.hidden { display: none; }

/* Header with Wave */
.fyncall-home-header {
    background: linear-gradient(135deg, var(--fyncall-primary) 0%, color-mix(in srgb, var(--fyncall-primary) 80%, transparent) 100%);
    padding: 20px 16px 48px;
    color: white;
    position: relative;
    overflow: hidden;
}
.fyncall-home-header::before {
    content: '';
    position: absolute;
    top: -50%;
    right: -50%;
    width: 100%;
    height: 100%;
    background: radial-gradient(circle, rgba(255,255,255,0.1) 0%, transparent 70%);
    pointer-events: none;
}
.fyncall-home-header::after {
    content: '';
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    height: ${config.headerCurveStyle === 'none' ? '0' : config.headerCurveStyle === 'rounded' ? '20px' : '22px'};
    background: ${config.headerCurveStyle === 'none' ? 'transparent' : 'white'};
    border-radius: ${config.headerCurveStyle === 'none' ? '0' : config.headerCurveStyle === 'rounded' ? '16px 16px 0 0' : '24px 24px 0 0'};
    pointer-events: none;
}
.fyncall-home-topbar {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-bottom: 16px;
    position: relative;
    z-index: 1;
}
.fyncall-home-logo {
    width: 48px;
    height: 48px;
    border-radius: 12px;
    background: rgba(255,255,255,0.2);
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-home-logo img {
    width: 40px;
    height: 40px;
    border-radius: 8px;
    object-fit: cover;
}
.fyncall-home-logo-text {
    font-size: 18px;
    font-weight: 700;
    color: white;
    letter-spacing: -0.3px;
}
.fyncall-home-branding {
    display: flex;
    align-items: center;
    gap: 12px;
}
.fyncall-home-company-name {
    font-size: 16px;
    font-weight: 600;
    color: white;
}
.fyncall-home-minimize {
    background: transparent;
    border: none;
    color: white;
    cursor: pointer;
    padding: 6px;
    line-height: 1;
    border-radius: 8px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    z-index: 10;
}
.fyncall-home-minimize:hover {
    background: rgba(255,255,255,0.1);
}
.fyncall-home-minimize svg {
    width: 20px;
    height: 20px;
}
.fyncall-home-close {
    background: rgba(255,255,255,0.15);
    backdrop-filter: blur(4px);
    border: none;
    color: white;
    cursor: pointer;
    padding: 8px;
    line-height: 1;
    border-radius: 10px;
    transition: all 0.2s;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-home-close:hover {
    background: rgba(255,255,255,0.25);
    transform: scale(1.05);
}
.fyncall-home-close svg {
    width: 18px;
    height: 18px;
}
.fyncall-home-greeting {
    position: relative;
    z-index: 1;
}
.fyncall-home-title {
    font-size: 20px;
    font-weight: 500;
    color: white;
    margin: 0 0 4px;
    line-height: 1.2;
}
.fyncall-home-subtitle {
    font-size: 14px;
    color: rgba(255,255,255,0.8);
    margin: 0;
    font-weight: 400;
}

/* Online Status in Header */
.fyncall-home-status {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: 12px;
    font-size: 12px;
    color: rgba(255,255,255,0.7);
}
.fyncall-status-dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background: #22c55e;
    animation: fyncall-pulse-dot 2s ease-in-out infinite;
}
@keyframes fyncall-pulse-dot {
    0%, 100% { opacity: 1; transform: scale(1); }
    50% { opacity: 0.7; transform: scale(1.1); }
}

.fyncall-home-content {
    flex: 1;
    overflow-y: auto;
    padding: 8px 16px 16px;
    display: flex;
    flex-direction: column;
    gap: 24px;
}

/* Conversation Starter Card */
.fyncall-conversation-starter {
    background: white;
    border-radius: 12px;
    padding: 16px;
    box-shadow: 0 1px 3px rgba(0,0,0,0.05);
    border: 1px solid #f1f5f9;
}
.fyncall-starter-header {
    display: flex;
    align-items: center;
    gap: 12px;
    margin-bottom: 12px;
}
.fyncall-starter-avatars {
    display: flex;
}
.fyncall-starter-avatar {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    background: var(--fyncall-primary-light);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}
.fyncall-starter-avatar.has-image {
    background: transparent;
}
.fyncall-starter-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
}
.fyncall-starter-avatar svg {
    width: 20px;
    height: 20px;
    stroke: var(--fyncall-primary);
}
.fyncall-starter-info h3 {
    font-size: 14px;
    font-weight: 500;
    color: #1e293b;
    margin: 0;
}
.fyncall-starter-info p {
    font-size: 12px;
    color: #64748b;
    margin: 0;
    display: flex;
    align-items: center;
    gap: 4px;
}
.fyncall-starter-info .fyncall-online-indicator {
    width: 6px;
    height: 6px;
    border-radius: 50%;
    background: #22c55e;
}
/* Start a Chat Button */
.fyncall-start-chat-btn {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: var(--fyncall-primary);
    color: white;
    border: none;
    border-radius: 12px;
    padding: 12px 16px;
    font-size: 14px;
    font-weight: 500;
    cursor: pointer;
    transition: all 0.2s;
}
.fyncall-start-chat-btn:hover {
    opacity: 0.9;
}
.fyncall-start-chat-btn:active {
    opacity: 0.95;
}
.fyncall-start-chat-btn svg {
    width: 16px;
    height: 16px;
    stroke: white;
    fill: none;
}

/* Section Labels */
.fyncall-home-section-label {
    font-size: 12px;
    font-weight: 600;
    color: #6b7280;
    margin: 20px 0 12px 4px;
}

/* Quick Actions - 3 Column Grid */
.fyncall-home-actions {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 8px;
    padding: 4px 0 12px;
}
.fyncall-action-card {
    background: white;
    border-radius: 12px;
    padding: 12px 8px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 6px;
    cursor: pointer;
    transition: all 0.2s;
    box-shadow: 0 2px 4px rgba(0,0,0,0.04);
    border: 1px solid #f1f5f9;
    text-align: center;
}
.fyncall-action-card:hover {
    box-shadow: 0 4px 12px rgba(0,0,0,0.08);
    transform: translateY(-2px);
    border-color: var(--fyncall-primary);
}
.fyncall-action-icon {
    font-size: 24px;
    line-height: 1;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-action-icon svg {
    width: 24px;
    height: 24px;
    stroke: var(--fyncall-primary);
    fill: none;
}
.fyncall-action-text {
    font-size: 12px;
    font-weight: 500;
    color: #374151;
    line-height: 1.3;
    word-break: break-word;
}

/* FAQ Topics Section - Separate Rounded Buttons */
.fyncall-faq-section {
    display: flex !important;
    flex-direction: column !important;
    gap: 8px !important;
}
.fyncall-faq-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 8px;
    padding: 12px;
    font-size: 14px;
    color: #334155;
    cursor: pointer;
    transition: all 0.15s;
    border: 1px solid #e2e8f0;
    background: white;
    width: 100%;
    text-align: left;
    border-radius: 12px;
    margin-bottom: 8px;
}
.fyncall-faq-item:last-child {
    margin-bottom: 0;
}
.fyncall-faq-item:hover {
    border-color: #cbd5e1;
}
.fyncall-faq-text {
    flex: 1;
    line-height: 1.4;
}
.fyncall-faq-arrow {
    width: 16px;
    height: 16px;
    flex-shrink: 0;
    color: #94a3b8;
}
.fyncall-faq-item:hover .fyncall-faq-arrow {
    color: #64748b;
}

/* Chat Entry Card - Hidden by default, use conversation starter instead */
.fyncall-chat-entry {
    display: none;
}

/* Powered By Footer */
.fyncall-home-footer {
    padding: 8px 16px;
    text-align: center;
    border-top: 1px solid #e2e8f0;
    background: #f8fafc;
}
.fyncall-home-footer a {
    font-size: 12px;
    color: #94a3b8;
    text-decoration: none;
    transition: color 0.2s;
    cursor: pointer;
}
.fyncall-home-footer a:hover {
    color: #475569;
}

/* Chat View Styling Updates */
#fyncall-chat-view {
    display: none;
    flex-direction: column;
    height: 100%;
}
#fyncall-chat-view.active { display: flex; }

.fyncall-chat-back {
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 4px;
    margin-right: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
}
.fyncall-chat-back svg {
    width: 20px;
    height: 20px;
    stroke: white;
    fill: none;
}
    `;
}
